<template>
  <div>
    <page-header
      left-side-class="col-xl-4"
      :page="pageHeaderConfig"
      right-side-class="col-xl-8 align-items-end d-flex pb-2 justify-content-end"
    >
      <template v-if="!showChangeBillingStatus" #customActions>
        <action-button
          i="fas fa-arrow-circle-left"
          variant="success"
          @click="goToBillingHistorySearch()"
        >
          Regresar
        </action-button>
        <div class="dropdown">
          <button
            v-if="userHasPermissions('provider.billing.history.report')"
            id="dropdownMenuButton"
            aria-expanded="false"
            aria-haspopup="true"
            class="btn btn-dropdown-actions dropdown-toggle float-left pt-1 color-green font-weight-bold d-flex justify-content-center align-items-center mx-2"
            data-toggle="dropdown"
            type="button"
          >
            <em class="fa fa-file-alt text-green pr-2" />
            <span class="color-green font-weight-bold">Informes</span>
          </button>
          <div
            aria-labelledby="dropdownMenuButton"
            class="dropdown-menu dropdown-menu-right custom-dropdown-container"
          >
            <div
              v-for="(reportButton, index) in reportButtonAvailables"
              :key="index"
              class="dropdown-item cursor-pointer mb-1"
              @click="reportButton.callback"
            >
              <em class="fa fa-file-alt text-green pr-1" />
              <span>{{ reportButton.text }}</span>
            </div>
          </div>
        </div>
        <action-button
          v-if="showDistributionButton"
          i="fas fa-file-search"
          variant="success"
          @click="onShowDistributionDetailsPanel"
        >
          Detalles de Distribución
        </action-button>
        <action-button
          v-if="
            userHasPermissions('provider.bill.total.update') &&
              isPreliminar &&
              isActiveTabSummary
          "
          class="ml-2"
          i="fas fa-redo-alt"
          variant="success"
          @click="updateBillTotals"
        >
          Actualizar Factura
        </action-button>
        <action-button
          v-if="enableSubmitBilling"
          i="fas fa-flag"
          text="Someter"
          variant="success ml-2"
          @click="onSubmitBill"
        />
        <action-button
          v-if="enableChangeBillingStatus"
          i="fas fa-exchange-alt"
          text="Cambiar Estatus"
          variant="success ml-2"
          @click="onChangeBillingStatusForm"
        />
        <action-button
          v-if="canDoPartialPayment"
          i="fa fa-usd-square"
          text="Pago Parcial"
          variant="success ml-2"
          @click="addPartialPayments"
        />
        <action-button
          v-if="canAjustBill"
          i="fas fa-money-check-alt"
          text="Ajustar Factura"
          variant="success ml-2"
          @click="onBillingAdjustmentForm"
        />
      </template>
    </page-header>
    <div v-if="enableChangeBillingStatus && showChangeBillingStatus">
      <custom-callout
        border-color="green"
        class="mb-4 custom-callout-invoice shadow"
        :has-toggle="false"
      >
        <div class="row">
          <div class="col-md-12">
            <icon-view
              icon="fa fa-clipboard-list-check"
              icon-background="#fff"
              icon-color="#2db782"
              icon-size="16px"
              title="Cambiar Estatus de Factura"
            />
          </div>
        </div>
        <validation-observer
          ref="submitUpdateBillingStatusRef"
          novalidate
          tag="form"
        >
          <div class="row ml-2 mt-3">
            <div class="col-md-3 col-sm-12">
              <div class="gray-6 font-14 mb-2">
                Nuevo Estatus:
              </div>
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-drop-down
                  v-model="billingStatusModel.billStatusId"
                  :clearable="false"
                  custom-error-msg="Favor de seleccionar el nuevo estatus."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="billingStatusListAvailable"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="gray-6 font-14 mb-2">
                Comentario:
              </div>
              <validation-provider
                v-slot="{ errors }"
                :rules="requiredChangeStatusComment ? 'required' : ''"
              >
                <custom-input
                  v-model="billingStatusModel.comment"
                  custom-error-msg="Favor de entrar un comentario."
                  :error="errors[0]"
                />
              </validation-provider>
            </div>
            <div class="col-md-3 text-right mt-4">
              <action-button
                class="w-45"
                i="fas fa-times-circle"
                variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
                @click="onCancelBillingStatusHandler"
              >
                Cancelar
              </action-button>
              <action-button
                i="fas fa-arrow-circle-right"
                variant="success pl-4 pr-4"
                @click="onChangeBillingStatusHandler"
              >
                Continuar
              </action-button>
            </div>
          </div>
          <div
            v-if="enableExtraFieldChangeStatus(billingStatusModel.billStatusId)"
            class="ml-4"
          />
        </validation-observer>
      </custom-callout>
    </div>

    <billing-distribution-details
      v-if="showDistribution"
      :data="distributionInfo"
      @on-close="onShowDistributionDetailsPanel($event)"
    />

    <div v-if="showGeneralAdjustmentForm">
      <custom-callout
        border-color="green"
        class="mb-4 custom-callout-invoice shadow"
        :has-toggle="false"
      >
        <div class="row">
          <div class="col-md-12">
            <icon-view
              icon="fas fa-money-check-alt"
              icon-background="#fff"
              icon-color="#2db782"
              icon-size="16px"
              title="Ajuste de Factura"
            />
          </div>
        </div>
        <validation-observer ref="generalAdjustmentRef" novalidate tag="form">
          <div class="row ml-2 mt-3">
            <div class="col-md-6 col-sm-12">
              <div class="gray-6 font-14 mb-2">
                Razón:
              </div>
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-drop-down
                  v-model="generalAdjustmentModel.reason"
                  :clearable="false"
                  custom-error-msg="Favor seleccionar razón del ajuste."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="reasons"
                  placeholder="Seleccione"
                  @input="onReasonChange"
                />
              </validation-provider>
            </div>
            <div class="col-md-3 col-sm-12">
              <div class="font-14 color-gray-6 mb-1">
                Cantidad:
              </div>
              <validation-provider v-slot="{ errors }" rules="required">
                <div class="input-group mb-3">
                  <div class="input-amount-dollar">
                    <em class="fa fa-dollar-sign" />
                  </div>
                  <custom-input
                    v-model="generalAdjustmentModel.amount"
                    class="w-80"
                    custom-error-msg=""
                    :error="errors[0]"
                    type="number"
                  />
                  <div class="input-amount-action">
                    <em
                      class="fa fa-plus-circle"
                      @click="onChangeAmountSign('positive')"
                    />
                    <em
                      class="fa fa-minus-circle"
                      @click="onChangeAmountSign('negative')"
                    />
                  </div>
                </div>
                <error
                  v-if="errors[0]"
                  message="Cantidad del ajuste es requerida."
                  variant="no-border mt-n3"
                />
              </validation-provider>
            </div>
            <div class="col-md-9 col-sm-12">
              <div class="gray-6 font-14 mb-2">
                Comentario:
              </div>
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="generalAdjustmentModel.comment"
                  custom-error-msg="Comentario es requerido para registrar el ajuste."
                  :error="errors[0]"
                />
              </validation-provider>
            </div>
            <div class="col-md-3 text-right mt-4">
              <action-button
                i="fas fa-times-circle"
                variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
                @click="onBillingAdjustmentForm"
              >
                Cancelar
              </action-button>
              <action-button
                i="fas fa-arrow-circle-right"
                variant="success pl-4 pr-4"
                @click="onSaveGeneralAdjustment"
              >
                Guardar
              </action-button>
            </div>
          </div>
        </validation-observer>
      </custom-callout>
    </div>

    <board :details="invoiceDetailsBoard" />
    <div class="mt-5">
      <section-title :has-line="true" title="Información de Factura" />
      <div>
        <custom-tab
          active-tab-class=""
          class="custom-nav-container"
          content-class="mt-3"
          :no-nav-style="true"
        >
          <custom-tab-item
            :active="billingInfoTabIndex === billingInfoTabs.SUMMARY"
            lazy
            title="Resumen"
            @click="onChangeInfoTab(billingInfoTabs.SUMMARY)"
          >
            <div class="row">
              <div class="col-md-4 col col-sm-6">
                <total-amount-view
                  :amount="summaryTotals.subTotal | price"
                  icon="fa fa-usd-circle"
                  icon-color="color-yellow-star"
                  title="Total Facturado"
                />
              </div>
              <div class="col-md-4 col col-sm-6 mt-3 mt-md-0 mt-sm-3">
                <total-amount-view
                  :amount="summaryTotals.adjustment | price"
                  icon="fa fa-usd-circle"
                  icon-color="color-primary-8"
                  title="Total de Ajustes en Factura"
                />
              </div>
              <div
                class="col-md-4 col col-sm-6 mt-md-0 mt-sm-3 mt-3 mt-md-0 mt-sm-3"
              >
                <total-amount-view
                  :amount="summaryTotals.total | price"
                  icon="fa fa-usd-circle"
                  icon-color="color-green"
                  title="Total a Pagar"
                />
              </div>
            </div>
            <hr />
            <div class="row mt-4 mb-3 ml-2">
              <div
                class="col-md-4 col-sm-12 mt-md-0 mt-sm-3 ml-n4 ml-md-n0 ml-sm-n4 mr-4"
              >
                <service-type-view
                  :amount-sub-total="serviceTotals.therapyServiceAmount | price"
                  :collapsed="showInterventionService"
                  :details="interventionServiceDetail"
                  enable-toggle
                  main-icon="fa fa-clipboard-list"
                  main-title="Resumen de Servicio de Intervención"
                  :service-total="
                    serviceTotals.therapyServiceCount
                      ? serviceTotals.therapyServiceCount.toString()
                      : '0'
                  "
                  :show-total="canShowTotalDetail"
                  @on-toggle="onToggleServiceInfo"
                />
              </div>
              <div
                class="col-md-4 col-sm-12 mt-5 mt-md-0 mt-sm-5 corner-line ml-n4 ml-md-n0 ml-sm-n4 mr-4"
              >
                <service-type-view
                  :amount-sub-total="
                    serviceTotals.evaluationServiceAmount | price
                  "
                  :details="evaluationServiceDetail"
                  main-icon="fa fa-clipboard-list"
                  main-title="Resumen de Evaluación"
                  :service-total="
                    serviceTotals.evaluationServiceCount
                      ? serviceTotals.evaluationServiceCount.toString()
                      : '0'
                  "
                  :show-total="canShowTotalDetail"
                />
              </div>
              <div
                class="col-md-4 col-sm-12 mt-5 mt-md-0 mt-sm-5 ml-n4 ml-md-n0 ml-sm-n4"
              >
                <service-type-view
                  :amount-sub-total="serviceTotals.otherServiceAmount | price"
                  :amount-total="
                    serviceTotals.otherServiceAmount +
                      serviceTotals.otherServiceAdjustmentAmount
                  "
                  main-icon="fa fa-clipboard-list"
                  main-title="Resumen de Otros Servicios"
                  :service-total="
                    serviceTotals.otherServiceCount
                      ? serviceTotals.otherServiceCount.toString()
                      : '0'
                  "
                  :show-total="canShowTotalDetail"
                  :use-detail="false"
                />

                <service-type-view
                  :amount-sub-total="
                    serviceTotals.educationalServiceAmount | price
                  "
                  class="mt-3"
                  :collapsed="showEducationalServiceResume"
                  :details="educationalServiceDetail"
                  enable-toggle
                  main-icon="fa fa-clipboard-list"
                  main-title="Resumen de Servicios Educativos"
                  :service-total="
                    serviceTotals.educationalServiceCount
                      ? serviceTotals.educationalServiceCount.toString()
                      : '0'
                  "
                  @on-toggle="
                    {
                      showEducationalServiceResume = !showEducationalServiceResume;
                    }
                  "
                />
              </div>
            </div>
            <service-type-info-view
              :admission-info="interventionServiceInfo.admission"
              class="mt-n2 ml-5"
              :collapsed="showInterventionService"
              :plan-info="interventionServiceInfo.plan"
              :visit-info="interventionServiceInfo.visit"
              @on-toggle="onToggleServiceInfo"
            />

            <service-type-educational-info-view
              class="mt-n2 ml-5"
              :collapsed="showEducationalServiceResume"
              :educational-service-resume-details="educationalServiceresume"
              @on-toggle="
                {
                  showEducationalServiceResume = !showEducationalServiceResume;
                }
              "
            />

            <div class="my-4 ml-n1">
              <icon-view
                class="ml-1 mt-5 mt-md-0 mt-sm-5"
                gradient
                icon="fa fa-clipboard-list"
                icon-background="#C5525C"
                icon-color="#fff"
                title="Resumen de Alerta de Servicios"
              />
              <div class="row mt-3 ml-0 ml-md-1 ml-sm-0">
                <div class="col-md-4">
                  <service-alert-view
                    :count="alerts.errorVisits"
                    description="Servicios en la factura que tienen error en las visitas registradas."
                    main-title="Error de Visitas:"
                    @print="getErrorVisit"
                  />
                </div>
                <div class="col-md-4">
                  <service-alert-view
                    :count="alerts.noEnded"
                    description="Servicios en la factura que no han sido finalizados."
                    main-title="No Finalizados:"
                    @print="getWithouFinish"
                  />
                </div>
                <div class="col-md-4">
                  <service-alert-view
                    :count="alerts.withoutCertification"
                    description="Servicios en la factura que no tienen anejado la certificación de visita."
                    main-title="Sin Certificación de Visita:"
                    @print="getWithoutCertification"
                  />
                </div>
              </div>
            </div>
          </custom-tab-item>
          <custom-tab-item
            :active="billingInfoTabIndex === billingInfoTabs.DETAIL"
            lazy
            title="Detalle"
            @click="
              () => {
                onChangeInfoTab(billingInfoTabs.DETAIL);
              }
            "
          >
            <div
              v-if="!editingDistributionNumber"
              class="bg-gray-1 p-3 rounded"
            >
              <div class="row">
                <div class="col-md-3">
                  <custom-drop-down
                    v-model="selectedFilters.serviceCategory"
                    :clearable="true"
                    fieldkey="id"
                    fieldname="name"
                    label="Grupo de Edad:"
                    :options="ageGroupList"
                    placeholder="Seleccione"
                  />
                </div>
                <div class="col-md-3">
                  <custom-drop-down
                    v-model="selectedFilters.serviceType"
                    :clearable="true"
                    fieldkey="id"
                    fieldname="name"
                    label="Tipo de Servicio:"
                    :options="filters.serviceTypes"
                    placeholder="Seleccione"
                    @input="onChangeBillingServiceType"
                  />
                </div>
                <div v-if="showEvaluationTypeFilter" class="col-md-3">
                  <custom-drop-down
                    v-model="selectedFilters.evaluationType"
                    :clearable="true"
                    fieldkey="id"
                    fieldname="name"
                    label="Tipo de Evaluación:"
                    :options="filters.evaluationTypes"
                    placeholder="Seleccione"
                  />
                </div>
                <div class="col-md-3 mt-3 mt-md-0 mt-sm-3">
                  <custom-drop-down
                    v-model="selectedFilters.disciplineType"
                    :clearable="true"
                    fieldkey="id"
                    fieldname="name"
                    label="Servicio:"
                    :options="filters.disciplineTypes"
                    placeholder="Seleccione"
                    @input="onChangeBillingDisciplineType"
                  />
                </div>
                <div
                  class="col-md-3"
                  :class="{ 'mt-3': showEvaluationTypeFilter }"
                >
                  <custom-drop-down
                    v-model="selectedFilters.specialist"
                    :clearable="true"
                    fieldkey="id"
                    fieldname="name"
                    label="Especialista:"
                    :options="filters.specialists"
                    placeholder="Seleccione"
                  />
                </div>
                <div
                  v-if="showBillingServiceAlert(selectedFilters.serviceType)"
                  class="col-md-3 mt-3"
                >
                  <custom-drop-down
                    v-model="selectedFilters.alert"
                    :clearable="true"
                    fieldkey="id"
                    fieldname="name"
                    label="Alertas:"
                    :options="serviceAlertTypes"
                    placeholder="Seleccione"
                  />
                </div>
                <div
                  v-if="showBillingServiceSie(selectedFilters.disciplineType)"
                  class="col-md-3 mt-3"
                >
                  <custom-input
                    v-model="selectedFilters.sie"
                    label="SIE:"
                    placeholder="Escriba número de SIE"
                  />
                </div>
                <div v-if="showInterventionFilter" class="col-md-3 mt-3">
                  <custom-drop-down
                    v-model="selectedFilters.checkedFlag"
                    :clearable="true"
                    fieldkey="value"
                    fieldname="name"
                    label="Servicio Intervenido:"
                    :options="checkedOptions"
                    placeholder="Seleccione"
                  />
                </div>
                <div class="col d-flex d-md-block d-sm-flex mt-5 text-right">
                  <action-button
                    class="flex-grow-1"
                    i="fas fa-search"
                    text="Buscar"
                    variant="success"
                    @click="onSearchBillingServiceHandler"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="row justify-content-end">
                  <div v-if="canSelectNumberType" class="col">
                    <div class="d-flex mt-3">
                      <div class="col-auto">
                        <div class="color-gray-6 font-14 font-weight-normal">
                          Seleccione el Tipo de Cifra:
                        </div>
                      </div>
                      <div class="col">
                        <custom-radio
                          id="isFederalNumber"
                          v-model="isFederalNumber"
                          class="custom-radio__extended"
                          is-inline
                          name="isFederalNumber"
                          :options="numberTypeOptions"
                          @input="onToggleNumberType"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      canEditDistributionNumber && !editingDistributionNumber
                    "
                    class="col-auto"
                  >
                    <Link
                      id="editingDistributionNumber"
                      class="justify-content-end mt-3"
                      icon="fa fa-edit"
                      text="Modificar Distribución de Cifras de Cuenta"
                      @click="setDistributionNumberFlag"
                    />
                  </div>
                  <div v-if="canDownloadMassCertifications" class="col-auto">
                    <Link
                      id="bulkDownload"
                      class="justify-content-end mt-3"
                      icon="fa fa-file-download"
                      text="Descargar Certificaciones en Masa"
                      @click="bulkDownload"
                    />
                  </div>
                  <div v-if="canMarkAllAsIntervened" class="col-auto">
                    <Link
                      id="markAllService"
                      class="justify-content-end mt-3"
                      icon="fa fa-flag"
                      text="Marcar Todos como Servicio Intervenido"
                      @click="markAllService"
                    />
                  </div>
                </div>
                <div v-if="editingDistributionNumber" class="mt-4">
                  <edit-distribution-number
                    :age-group-list="ageGroupList"
                    :bill-id="billId"
                    :purchase-orders="purchaseOrdersByCompany"
                    :purchase-orders-in-bill="projectNumbersInBill"
                    @cancel-edit="setDistributionNumberFlag(false)"
                    @updated="onUpdateDistributionNumber"
                  />
                </div>
                <div class="mt-4">
                  <div
                    v-for="(item, index) in pagination.data"
                    :key="'service-details' + index"
                  >
                    <custom-callout
                      class="mb-3 custom-callout"
                      :controlled="true"
                      :has-toogle="true"
                      :opened="item.isOpen"
                      @click:open="onToggleServiceAdditionalInfo(item)"
                    >
                      <div class="row">
                        <div
                          class="col-md-2 col-sm-12 col-spacing student-spacing"
                        >
                          <div class="legend">
                            {{
                              item.evaluationTypeName || item.serviceTypeName
                            }}
                          </div>
                          <div class="font-weight-normal color-black">
                            {{ item.disciplineName }}
                          </div>
                        </div>
                        <div
                          class="col-md-2 col-sm-12 col-spacing service-place-spacing"
                        >
                          <div class="legend">
                            Estudiante:
                          </div>
                          <div class="font-weight-normal color-black">
                            {{ emptyText(item.studentName) }}
                          </div>
                        </div>
                        <div class="col-md-1 col-sm-12 col-spacing">
                          <div class="legend">
                            SIE:
                          </div>
                          <div class="font-weight-normal color-black">
                            {{ emptyText(item.studentSieId) }}
                          </div>
                        </div>
                        <div class="col-md-2 col-sm-12 col-spacing">
                          <div v-if="item.isEducativeService" class="legend">
                            {{
                              item.isForAssistanceServiceFlag === true
                                ? 'Asistente de Servicio:'
                                : 'Maestro:'
                            }}
                          </div>
                          <div v-else class="legend">
                            Especialista:
                          </div>
                          <div class="font-weight-normal color-black">
                            {{ item.fullName }}
                          </div>
                        </div>
                        <div class="col-md-1 col-sm-12 col-spacing">
                          <div class="legend">
                            Conteo:
                          </div>
                          <div class="font-weight-normal color-black">
                            {{ emptyText(item.recordCount) }}
                          </div>
                        </div>
                        <div
                          class="col-sm-12 col-spacing"
                          :class="{
                            'col-md-1': item.isElegible,
                            'col-md-2': !item.isElegible,
                          }"
                        >
                          <div class="legend">
                            Costo:
                          </div>
                          <div class="font-weight-normal color-black">
                            {{
                              (item.costAmount +
                                item.educationServiceCostAmount)
                                | price
                            }}
                          </div>
                        </div>
                        <div
                          v-if="item.isElegible"
                          class="col-md-1 col-sm-12 col-spacing"
                        >
                          <badge text="Elegible" :value="item.isElegible" />
                        </div>
                        <div
                          class="col-md-2 col-sm-12 col-spacing text-right pt-4"
                        >
                          <div
                            v-if="enableBillingAdjustment"
                            class="d-flex justify-content-around"
                          >
                            <action-button
                              v-if="
                                canDownloadDocument &&
                                  !isConsultingService(item)
                              "
                              class="custom-print-button"
                              i="fas fa-download"
                              variant="outline-success"
                              @click="evaluateDownload(item)"
                            />
                            <action-button
                              v-if="isConsultingService(item)"
                              class="custom-print-button"
                              i="far fa-search-plus"
                              variant="outline-success"
                              @click="viewVisitDetailHandler(item, index)"
                            />
                            <action-button
                              v-if="canMarkAsIntervened"
                              class="custom-flag-button d-flex justify-content-center align-items-center px-1"
                              i="far fa-flag pl-0 mx-2"
                              :variant="
                                item.checkedFlag ? 'success' : 'outline-success'
                              "
                              @click="checkUncheckService(item, index)"
                            />
                            <div>
                              <action-button
                                aria-expanded="false"
                                aria-haspopup="true"
                                class="custom-print-button"
                                data-toggle="dropdown"
                                i="fas fa-ellipsis-h"
                                variant="outline-success"
                              />
                              <div
                                aria-labelledby="dropdownMenuButton"
                                class="dropdown-menu dropdown-menu-right custom-dropdown-container"
                              >
                                <div
                                  v-if="isEvaluationService(item) == false"
                                  class="dropdown-item cursor-pointer mb-1"
                                  @click="viewVisitDetailHandler(item, index)"
                                >
                                  <em
                                    class="fa fa-file-search text-green pr-1"
                                  />
                                  <span>Detalle Visita</span>
                                </div>
                                <hr
                                  v-if="isEvaluationService(item) == false"
                                  class="mt-2"
                                />
                                <div
                                  v-if="canDoAjustToBill"
                                  class="dropdown-item cursor-pointer mt-n2"
                                  @click="viewBillingAdjusment(item, index)"
                                >
                                  <em class="fa fa-cog text-green pr-1" />
                                  <span class="ml-1">Ajustar</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="
                              !isDirectorCentro &&
                                userHasPermissions(
                                  'provider.bill.admissionnote.view'
                                )
                            "
                            class="dropdown d-flex justify-content-end align-items-center mt-3 mr-3"
                          >
                            <action-button
                              v-if="
                                isAdditionalInfoTypeConsulting(
                                  item.transactionType
                                )
                              "
                              class="custom-print-button "
                              i="fas fa-download"
                              variant="outline-success mr-3"
                              @click="downloadConsultingDocument(item.id)"
                            />
                            <button
                              id="dropdownMenuButton"
                              aria-expanded="false"
                              aria-haspopup="true"
                              class="btn btn-dropdown-actions dropdown-toggle float-right"
                              data-toggle="dropdown"
                              type="button"
                            >
                              Acciones
                            </button>
                            <div
                              aria-labelledby="dropdownMenuButton"
                              class="dropdown-menu dropdown-menu-right custom-dropdown-container"
                            >
                              <div
                                v-if="
                                  item.transactionType ==
                                    billingLevelEnum.visit ||
                                    item.transactionType ==
                                      billingLevelEnum.educational
                                "
                                class="dropdown-item cursor-pointer mb-1"
                                @click="viewVisitDetailHandler(item, index)"
                              >
                                <em class="fa fa-file-search text-green pr-1" />
                                <span>Ver Detalle Visita</span>
                              </div>
                              <div
                                v-if="
                                  item.transactionType ==
                                    billingLevelEnum.educational &&
                                    !isPreliminar
                                "
                                class="dropdown-item cursor-pointer mb-1"
                                @click="openEducationalServiceTab(index)"
                              >
                                <em class="fa fa-file-search text-green pr-1" />
                                <span>Ver detalle de Servicios</span>
                              </div>
                              <div
                                v-if="
                                  canEditVist(item) &&
                                    isVisitType(item) &&
                                    isPreliminar
                                "
                                class="dropdown-item cursor-pointer"
                                @click="editVisitHandler(item)"
                              >
                                <em class="fa fa-file-edit text-green pr-1" />
                                <span class="ml-2">
                                  {{ editVisitTitle(item) }}
                                </span>
                              </div>
                              <div
                                v-if="
                                  !item.isPlanSubmitted &&
                                    showPlanDownload(item.disciplineTypeCd) &&
                                    item.transactionType ===
                                      billingLevelEnum.visit
                                "
                              >
                                <hr class="mt-2" />
                                <div
                                  class="dropdown-item cursor-pointer mt-n2"
                                  @click="
                                    onPlanInterventionRevisionDownload(item)
                                  "
                                >
                                  <em
                                    class="fa fa-file-search text-green pr-1"
                                  />
                                  <span>Descargar Plan</span>
                                </div>
                              </div>
                              <div v-if="item.isPlanSubmitted">
                                <hr class="mt-2" />
                                <div
                                  class="dropdown-item cursor-pointer mt-n2"
                                  @click="ViewPlanHandler(item)"
                                >
                                  <em
                                    class="fa fa-file-search text-green pr-1"
                                  />
                                  <span>Ver Plan</span>
                                </div>
                              </div>

                              <div
                                v-if="
                                  item.isAdmissionRecord &&
                                    userHasPermissions(
                                      'provider.bill.admissionnote.view'
                                    )
                                "
                              >
                                <hr class="mt-2" />
                                <div
                                  class="dropdown-item cursor-pointer mt-n2"
                                  @click="viewAdmissionDetail(item)"
                                >
                                  <em
                                    class="fa fa-file-search text-green pr-1"
                                  />
                                  <span>Ver Nota de Admisión</span>
                                </div>
                              </div>
                              <div
                                v-if="
                                  (isUserProvider || isAdminProvider) &&
                                    isThrpyService(item) &&
                                    item.transactionType == 1
                                "
                              >
                                <hr class="mt-2" />
                                <div
                                  class="dropdown-item cursor-pointer mt-n2"
                                  @click="openCertificationVisit(item, index)"
                                >
                                  <em class="fa fa-file-plus text-green pr-1" />
                                  <span class="ml-1">
                                    Certificación de Visita
                                  </span>
                                </div>
                              </div>
                              <div
                                v-if="isEducativeService(item.disciplineTypeCd)"
                              >
                                <div
                                  class="dropdown-item cursor-pointer mt-2"
                                  @click="openServiceProposal(item, index)"
                                >
                                  <em
                                    class="fa fa-file-download text-green pr-1"
                                  />
                                  <span class="ml-1">
                                    Documentos de Propuesta
                                  </span>
                                </div>
                              </div>
                              <div v-if="item.transactionType == 2">
                                <div
                                  class="dropdown-item cursor-pointer mb-1"
                                  @click="onEvaluationAppointmentDownload(item)"
                                >
                                  <em
                                    class="fa fa-file-search text-green pr-1"
                                  />
                                  <span>Descargar Evaluación</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <validation-observer
                        ref="purchaseOrders"
                        novalidate
                        tag="form"
                      >
                        <additional-purchase-order
                          v-if="viewBillingAdjustment"
                          :additional-info="pagination.data[index]"
                          :bill-status="billModel.statusId"
                          :is-federal-number="isFederalNumber"
                          :purchase-orders="purchaseOrdersByCompany"
                          :value="pagination.data[index].purchaseOrder"
                          @save="saveNumber(item, index)"
                          @update="
                            (value) =>
                              (pagination.data[index].purchaseOrder = value)
                          "
                        />
                      </validation-observer>
                      <template #edition>
                        <div class="p-3 pb-2 custom-callout-edition">
                          <div class="bg-secondary-3 rounded p-2">
                            <custom-tab
                              class="custom-tab-visit-details bg-white rounded"
                            >
                              <custom-tab-item
                                :active="visitDetailsTabIndex === 0"
                                content-class="mt-3 pb-3"
                                title="Información Adicional"
                                @click="
                                  onChangeToAdittionalInfo(item, index, 0)
                                "
                              >
                                <div class="px-4 pb-4">
                                  <div
                                    v-if="
                                      isAdditionalInfoTypeTherapy(
                                        item.transactionType
                                      )
                                    "
                                    class="row"
                                  >
                                    <div
                                      class="col col-sm col-12 mt-3 mt-md-0 mt-sm-3"
                                    >
                                      <div class="font-14 color-gray-6">
                                        Número de Referido:
                                      </div>
                                      <div class="font-14 color-black">
                                        {{
                                          item.details != undefined
                                            ? item.details.referrenceNumber
                                            : ' - '
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="col col-sm col-12 mt-3 mt-md-0 mt-sm-3"
                                    >
                                      <div class="font-14 color-gray-6">
                                        Modalidad:
                                      </div>
                                      <div class="font-14 color-black">
                                        {{
                                          item.details != undefined
                                            ? item.details.modality
                                            : ' - '
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="col col-sm col-12 mt-3 mt-md-0 mt-sm-3"
                                    >
                                      <div class="font-14 color-gray-6">
                                        Frecuencia:
                                      </div>
                                      <div class="font-14 color-black">
                                        {{
                                          item.details != undefined
                                            ? item.details.frequency
                                            : ' - '
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="col col-sm col-12 mt-3 mt-md-0 mt-sm-3"
                                    >
                                      <div class="font-14 color-gray-6">
                                        Duración:
                                      </div>
                                      <div class="font-14 color-black">
                                        {{
                                          item.details != undefined
                                            ? item.details.duration
                                            : ' - '
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      class="col col-sm col-12 mt-3 mt-md-0 mt-sm-3"
                                    >
                                      <div class="font-14 color-gray-6">
                                        Lugar de Servicio:
                                      </div>
                                      <div class="font-14 color-black">
                                        {{
                                          item.details != undefined
                                            ? item.details.locationService
                                            : ' - '
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    v-if="
                                      isAdditionalInfoTypeAppointment(
                                        item.transactionType
                                      )
                                    "
                                    class="row pb-3"
                                  >
                                    <div class="col">
                                      <div class="font-14 color-gray-6">
                                        Número Cita:
                                      </div>
                                      <div class="font-14 color-black">
                                        {{
                                          (item.details != undefined) != null
                                            ? item.details.referrenceNumber
                                            : ' - '
                                        }}
                                      </div>
                                    </div>
                                    <div class="col">
                                      <div class="font-14 color-gray-6">
                                        Lugar de Servicio:
                                      </div>
                                      <div class="font-14 color-black">
                                        {{
                                          (item.details != undefined) != null
                                            ? item.details.locationService
                                            : ' - '
                                        }}
                                      </div>
                                    </div>
                                    <div class="col">
                                      <div class="font-14 color-gray-6">
                                        Fecha de Completado:
                                      </div>
                                      <div class="font-14 color-black">
                                        {{
                                          setFormatOrEmpty(
                                            item.details.completedDate,
                                            'date'
                                          )
                                        }}
                                      </div>
                                    </div>
                                    <div
                                      v-if="
                                        item.details &&
                                          item.details
                                            .hasSignLanguageInterpreter
                                      "
                                      class="col"
                                    >
                                      <div class="font-14 color-gray-6">
                                        Intérprete de Señas
                                      </div>
                                      <div class="font-14 color-black">
                                        Sí
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    v-if="
                                      isAdditionalInfoTypeConsulting(
                                        item.transactionType
                                      )
                                    "
                                    class="row p-2"
                                  >
                                    <div class="col-md-6 pl-4 border-right">
                                      <div class="row">
                                        <div
                                          v-if="
                                            isVisibleMunicipality(
                                              item.disciplineTypeCd
                                            )
                                          "
                                          class="col-md-4"
                                        >
                                          <div class="font-14 color-gray-6">
                                            Municipio:
                                          </div>
                                          <div class="font-14 color-black">
                                            {{ item.details.municipalityName }}
                                          </div>
                                        </div>
                                        <div
                                          v-if="
                                            isVisiblePlace(
                                              item.disciplineTypeCd
                                            )
                                          "
                                          class="col-md-4"
                                        >
                                          <div class="font-14 color-gray-6">
                                            Lugar:
                                          </div>
                                          <div class="font-14 color-black">
                                            {{ item.details.locationName }}
                                          </div>
                                        </div>
                                        <div
                                          v-if="
                                            isVisibleParticipants(
                                              item.disciplineTypeCd
                                            )
                                          "
                                          class="col-md-4"
                                        >
                                          <div class="font-14 color-gray-6">
                                            Participantes:
                                          </div>
                                          <div class="font-14 color-black">
                                            {{
                                              item.details.participants.join(
                                                ' , '
                                              )
                                            }}
                                          </div>
                                        </div>
                                        <div
                                          v-if="
                                            isVisibleService(
                                              item.disciplineTypeCd
                                            )
                                          "
                                          class="col-md-4"
                                        >
                                          <div class="font-14 color-gray-6">
                                            Service:
                                          </div>
                                          <div class="font-14 color-black">
                                            {{ item.details.locationService }}
                                          </div>
                                        </div>
                                        <div
                                          v-if="
                                            isVisibleComment(
                                              item.disciplineTypeCd
                                            )
                                          "
                                          class="col-md-12 mt-3"
                                        >
                                          <div class="font-14 color-gray-6">
                                            Comentario:
                                          </div>
                                          <div class="font-14 color-black">
                                            {{ item.details.comment }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div
                                        v-for="(serviceDoc,
                                        serviceIndex) in item.details.documents"
                                        :key="`service-doc_${serviceIndex}`"
                                        class="d-flex flex-row justify-content-center align-items-center bg-secondary-3 py-3 px-3 ounded mr-3 mb-2"
                                      >
                                        <div class="flex-grow-1">
                                          <div class="font-14 color-gray-6">
                                            Tipo de Documento:
                                          </div>
                                          <div class="font-14 color-black">
                                            {{ serviceDoc.documentTypeName }}
                                          </div>
                                        </div>
                                        <div>
                                          <action-button
                                            class="custom-print-button"
                                            i="fas fa-download"
                                            variant="outline-success"
                                            @click="
                                              onDownloadServiceDocument(
                                                serviceDoc
                                              )
                                            "
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <educative-additional-info
                                    v-if="
                                      isAdditionalInfoTypeEducationalService(
                                        item.transactionType
                                      )
                                    "
                                    :show-assignment-dates="false"
                                    :show-start-date="true"
                                    :value="item.details || {}"
                                  />
                                </div>
                              </custom-tab-item>
                              <custom-tab-item
                                v-if="isThrpyService(item)"
                                key="1"
                                :active="visitDetailsTabIndex === 1"
                                class="pb-4"
                                content-class="mt-3 pb-3"
                                title="Certificación de Visita"
                                @click="openCertificationVisit(item, index)"
                              >
                                <validation-observer
                                  ref="submitCertDocRef"
                                  novalidate
                                  tag="form"
                                >
                                  <document-management
                                    v-model="item.certDocument"
                                    :document-types="certificationDocumentTypes"
                                    :readonly="!isPreliminar"
                                    @add-document="
                                      certVisitUploadDocument(item, index)
                                    "
                                    @cancel="
                                      openCertificationVisit(item, index)
                                    "
                                    @download-document="onDownload"
                                  />
                                </validation-observer>
                              </custom-tab-item>
                              <custom-tab-item
                                v-if="
                                  item.transactionType == 1 ||
                                    item.transactionType ==
                                      billingLevelEnum.educational
                                "
                                key="2"
                                :active="visitDetailsTabIndex === 2"
                                lazy
                                title="Detalles de Visita"
                                @click="viewVisitDetailHandler(item, index)"
                              >
                                <div
                                  v-if="
                                    item.details &&
                                      item.details.visitDetailsList
                                  "
                                  class="pb-4"
                                >
                                  <div
                                    v-for="(visitItem, visitIndex) in item
                                      .details.visitDetailsList.data"
                                    :key="`visit-details_${visitIndex}`"
                                    class="row mx-0 mx-md-4 mx-sm-0 p-3 border-bottom"
                                  >
                                    <div class="col-md-2">
                                      <div class="font-14 color-gray-6">
                                        Fecha:
                                      </div>
                                      <div class="font-14 color-black">
                                        {{
                                          $formatDate(
                                            visitItem.visitDate,
                                            $templateDate.default
                                          )
                                        }}
                                      </div>
                                    </div>
                                    <div class="col-md-3 mt-3 mt-md-0 mt-sm-3">
                                      <div class="font-14 color-gray-6">
                                        Horario:
                                      </div>
                                      <div class="font-14 color-black">
                                        {{ visitItem.completeTime }}
                                      </div>
                                    </div>
                                    <div class="col-md-2 mt-3 mt-md-0 mt-sm-3">
                                      <div class="font-14 color-gray-6">
                                        Tipo de Visita:
                                      </div>
                                      <div class="font-14 color-black">
                                        {{ visitItem.visitTypeName }}
                                      </div>
                                    </div>
                                    <div class="col-md-5">
                                      <div
                                        v-if="
                                          isEducativeService(
                                            item.disciplineTypeCd
                                          )
                                        "
                                        class="font-14 color-black"
                                      >
                                        <div>
                                          <div class="font-14 color-gray-6">
                                            Maestro:
                                          </div>
                                          {{ visitItem.visitSpecialistName }}
                                        </div>

                                        <div>
                                          <div class="font-14 color-gray-6">
                                            Asistente:
                                          </div>
                                          {{
                                            visitItem.assistanceServiceSpecialistName
                                          }}
                                        </div>
                                      </div>
                                      <div v-else class="font-14 color-black">
                                        <div class="font-14 color-gray-6">
                                          Especialista:
                                        </div>
                                        {{ visitItem.visitSpecialistName }}
                                        <div>
                                          {{ visitItem.locationService }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    v-if="
                                      item.details.visitDetailsList &&
                                        item.details.visitDetailsList.data &&
                                        item.details.visitDetailsList.pagination
                                          .totalItemCount >
                                          getVisitDetailsPaginationSize
                                    "
                                    class="mx-4"
                                  >
                                    <pagination
                                      :data="
                                        item.details.visitDetailsList.pagination
                                      "
                                      parent-id="visit-details"
                                      show-text
                                      @pagination-go-page="
                                        goToPageHandlerVisitDetails(
                                          $event,
                                          item,
                                          index
                                        )
                                      "
                                    />
                                  </div>
                                </div>
                              </custom-tab-item>
                              <custom-tab-item
                                v-if="
                                  enableBillingAdjustment && canDoAjustToBill
                                "
                                key="3"
                                :active="visitDetailsTabIndex === 3"
                                title="Ajustes"
                                @click="viewBillingAdjusment(item, index, true)"
                              >
                                <!-- Start -->
                                <validation-observer
                                  ref="adjustmentFormRef"
                                  novalidate
                                  tag="form"
                                >
                                  <div class="px-3">
                                    <div>
                                      <div class="row">
                                        <div class="col-md-3">
                                          <div
                                            class="font-14 color-gray-6 mb-1"
                                          >
                                            Nivel:
                                          </div>
                                          <div class="bg-gray-9 p-2 rounded">
                                            <validation-provider
                                              v-slot="{ errors }"
                                              rules="required"
                                            >
                                              <custom-radio
                                                :id="
                                                  `rbtn-level-${Math.random()}`
                                                "
                                                v-model="
                                                  adjustmentLevelSelected
                                                "
                                                :change-event="onChangeLevel"
                                                class="custom-radio__extended"
                                                custom-error-msg="Favor seleccione"
                                                :error="Boolean(errors[0])"
                                                is-inline
                                                name="rbAdjustLevel"
                                                :options="
                                                  getLevelOptions(
                                                    item.transactionType
                                                  )
                                                "
                                                type="questions"
                                              />
                                            </validation-provider>
                                          </div>
                                        </div>
                                        <div
                                          v-if="canViewVisitDate(item)"
                                          class="col-md-3"
                                        >
                                          <div>
                                            <div
                                              class="font-14 color-gray-6 mb-1"
                                            >
                                              Fecha de Visita:
                                            </div>
                                            <validation-provider
                                              v-slot="{ errors }"
                                              rules="required"
                                            >
                                              <custom-drop-down
                                                v-model="adjustmentVisit"
                                                :clearable="false"
                                                custom-error-msg="Favor de seleccionar la visita."
                                                :error="errors[0]"
                                                fieldkey="id"
                                                fieldname="name"
                                                :options="visits"
                                                placeholder="Seleccione"
                                              />
                                            </validation-provider>
                                          </div>
                                        </div>
                                        <div
                                          class="col-md-6"
                                          :class="{
                                            'col-md-9': !canViewVisitDate(item),
                                          }"
                                        >
                                          <div
                                            class="font-14 color-gray-6 mb-1"
                                          >
                                            Razón:
                                          </div>
                                          <validation-provider
                                            v-slot="{ errors }"
                                            rules="required"
                                          >
                                            <!-- Change -->
                                            <custom-drop-down
                                              v-model="adjustmentReasonId"
                                              :clearable="false"
                                              custom-error-msg="Favor seleccionar razón del ajuste."
                                              :error="errors[0]"
                                              fieldkey="id"
                                              fieldname="name"
                                              :options="reasons"
                                              placeholder="Seleccione"
                                              @input="onReasonChange"
                                            />
                                          </validation-provider>
                                        </div>
                                        <div class="col-md-3 mt-3">
                                          <div
                                            class="font-14 color-gray-6 mb-1"
                                          >
                                            Cantidad:
                                          </div>
                                          <validation-provider
                                            v-slot="{ errors }"
                                            rules="required"
                                          >
                                            <div class="input-group mb-3">
                                              <div class="input-amount-dollar">
                                                <em class="fa fa-dollar-sign" />
                                              </div>
                                              <custom-input
                                                v-model="adjustmentQuantity"
                                                class="w-50"
                                                custom-error-msg=""
                                                :error="errors[0]"
                                                type="number"
                                              />
                                              <div class="input-amount-action">
                                                <em
                                                  class="fa fa-plus-circle"
                                                  @click="
                                                    onChangeAmountSign(
                                                      'positive'
                                                    )
                                                  "
                                                />
                                                <em
                                                  class="fa fa-minus-circle"
                                                  @click="
                                                    onChangeAmountSign(
                                                      'negative'
                                                    )
                                                  "
                                                />
                                              </div>
                                            </div>
                                            <error
                                              v-if="errors[0]"
                                              message="Cantidad del ajuste es requerida."
                                              variant="no-border mt-n3"
                                            />
                                          </validation-provider>
                                        </div>
                                        <div class="col-md-9 mt-3">
                                          <div
                                            class="font-14 color-gray-6 mb-1"
                                          >
                                            Comentario:
                                          </div>
                                          <validation-provider
                                            v-slot="{ errors }"
                                            rules="required"
                                          >
                                            <custom-input
                                              v-model="adjustmentComment"
                                              custom-error-msg="Comentario es requerido para registrar el ajuste."
                                              :error="errors[0]"
                                            />
                                          </validation-provider>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col my-3 text-right">
                                          <action-button
                                            i="fa fa-save"
                                            variant="success pl-4 pr-4"
                                            @click="
                                              saveItemAdjustment(item, index)
                                            "
                                          >
                                            Guardar
                                          </action-button>
                                        </div>
                                      </div>
                                    </div>
                                    <hr class="mt-n1 mb-3" />
                                    <div class="row">
                                      <div class="col">
                                        <custom-callout
                                          v-for="(reasonItem,
                                          reasonIndex) in item.details
                                            .billingAdjustmentDetails"
                                          :key="
                                            'adjustment-reason' + reasonIndex
                                          "
                                          class="mb-3"
                                          :has-toggle="false"
                                        >
                                          <div class="row">
                                            <div
                                              class="col-md-2 col-sm-12 col-spacing student-spacing"
                                            >
                                              <div class="font-14 color-gray-6">
                                                Nivel:
                                              </div>
                                              <div class="color-black">
                                                {{
                                                  getTransactionName(reasonItem)
                                                }}
                                              </div>
                                            </div>
                                            <div
                                              v-if="!reasonItem.adjustmentDate"
                                              class="col-md-6 col-sm-12 col-spacing student-spacing"
                                            >
                                              <div class="font-14 color-gray-6">
                                                Razón:
                                              </div>
                                              <div
                                                class="color-black font-weight-normal"
                                              >
                                                {{
                                                  reasonItem.adjustmentReasonDescription
                                                }}
                                              </div>
                                            </div>
                                            <div
                                              v-if="reasonItem.adjustmentDate"
                                              class="col-md-6 col-sm-12 col-spacing student-spacing"
                                            >
                                              <div class="font-14 color-gray-6">
                                                Fecha de visita:
                                              </div>
                                              <div
                                                class="color-black font-weight-normal"
                                              >
                                                {{
                                                  $formatDate(
                                                    reasonItem.adjustmentDate,
                                                    $templateDate.default
                                                  )
                                                }}
                                              </div>
                                            </div>
                                            <div
                                              class="col-md-2 col-sm-12 col-spacing student-spacing"
                                            >
                                              <div class="font-14 color-gray-6">
                                                Cantidad:
                                              </div>
                                              <div
                                                class="color-black font-weight-normal"
                                              >
                                                {{
                                                  reasonItem.adjustmentAmt
                                                    | price
                                                }}
                                              </div>
                                            </div>
                                            <div
                                              class="col-md-2 mt-3 text-right"
                                            >
                                              <action-button
                                                i="fas fa-minus-circle"
                                                variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
                                                @click="
                                                  onDeleteBillingAdjustment(
                                                    item,
                                                    reasonItem,
                                                    index
                                                  )
                                                "
                                              >
                                                Eliminar
                                              </action-button>
                                            </div>
                                            <div
                                              v-if="reasonItem.comments"
                                              class="col-md-12 mt-n3 mb-3"
                                            >
                                              <hr />
                                              <div
                                                v-if="
                                                  reasonItem.adjustmentReasonDescription &&
                                                    reasonItem.adjustmentDate
                                                "
                                                class="mb-3"
                                              >
                                                <div
                                                  class="font-14 color-gray-6"
                                                >
                                                  Razón:
                                                </div>
                                                <div
                                                  class="color-black font-weight-normal"
                                                >
                                                  {{
                                                    reasonItem.adjustmentReasonDescription
                                                  }}
                                                </div>
                                              </div>
                                              <div
                                                class="font-14 color-gray-6 mb-1"
                                              >
                                                Comentario:
                                              </div>
                                              <div class="color-black">
                                                {{ reasonItem.comments }}
                                              </div>
                                            </div>
                                          </div>
                                        </custom-callout>
                                      </div>
                                    </div>
                                  </div>
                                </validation-observer>
                                <!-- End -->
                              </custom-tab-item>
                              <custom-tab-item
                                v-if="isEducativeService(item.disciplineTypeCd)"
                                key="4"
                                :active="visitDetailsTabIndex === 4"
                                class="pb-4"
                                lazy
                                title="Documentos de Propuesta"
                                @click="openServiceProposal(item, index)"
                              >
                                <educative-service-document-management
                                  :request-id="
                                    getAdditionalInfoIdByTransactionType(item)
                                  "
                                />
                              </custom-tab-item>
                              <custom-tab-item
                                v-if="showRetroactivePaymentsTab(item)"
                                :active="visitDetailsTabIndex === 7"
                                content-class="mt-3 pb-3"
                                title="Consulta de Pagos Retroactivos"
                                @click="
                                  onChangeToAdittionalInfo(
                                    item,
                                    index,
                                    billingServiceTabs.RETROACTIVE_PAYMENTS
                                  )
                                "
                              >
                                <retroactive-payments
                                  :readonly="true"
                                  :value="getRetroactivePaymentsDetails(item)"
                                />
                              </custom-tab-item>
                              <tab-service-detail
                                v-if="item.isEducativeService"
                                :active="visitDetailsTabIndex === 5"
                                :detail="serviceDetail"
                                :disable="!isPreliminar"
                                @getServiceDetail="
                                  () => getEducationalServiceDetails(item.id)
                                "
                                @update="
                                  (service, isRemoving) =>
                                    updateEducationalService(
                                      item,
                                      service,
                                      isRemoving
                                    )
                                "
                              />
                              <tab-service-summary
                                v-if="item.isEducativeService"
                                :active="visitDetailsTabIndex === 6"
                                :detail="servicesSummary"
                                @getServiceSummary="
                                  () =>
                                    getEducationalServicesSumarry(
                                      item.tapRequestId
                                    )
                                "
                              />
                            </custom-tab>
                          </div>
                        </div>
                      </template>
                    </custom-callout>
                    <section
                      v-if="
                        item.isEducativeService && !item.isOpen && isPreliminar
                      "
                      class="educative-info"
                    >
                      <div>
                        <span>
                          <i class="fa fa-file-invoice-dollar" />
                          Cuenta con servicios disponibles para facturar.
                          Presione
                          <label @click="openEducationalServiceTab(index)">
                            aquí
                          </label>
                          para comenzar.
                        </span>
                      </div>
                    </section>
                    <div
                      v-if="hasEducationEvaluation(item)"
                      class="service-warning-container"
                    >
                      <error
                        is-alert-mode
                        message="La evaluación Psicoeducativa fue identificada como Educativa al completar la misma. (R03200001)"
                        variant="no-border"
                      />
                    </div>
                  </div>
                  <custom-result-not-found
                    v-if="(this.pagination.data || []).length == 0"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="
                pagination.data.length > 0 &&
                  pagination.totalItemCount > pagination.count
              "
              class="row"
            >
              <div class="col-1 pt-4">
                <custom-drop-down
                  v-model="selectedPaging"
                  :clearable="false"
                  fieldkey="id"
                  fieldname="name"
                  :options="pagingList"
                  @input="onSelectedPagingHandler"
                />
              </div>
              <div class="col-11">
                <pagination
                  :data="pagination"
                  :page-size="pageSize"
                  :show-input-to-go="true"
                  show-text
                  @pagination-go-page="setCurrentDetailPage"
                />
              </div>
            </div>
          </custom-tab-item>
          <custom-tab-item
            :active="billingInfoTabIndex === billingInfoTabs.DOCUMENTS"
            class="mb-5"
            lazy
            title="Documentos"
            @click="
              () => {
                this.onChangeInfoTab(billingInfoTabs.DOCUMENTS);
                this.getBillingDocuments();
              }
            "
          >
            <callout
              v-if="invoiceDocuments.length == 0 && !addingDocument"
              class-main="py-3"
              :has-toggle="false"
            >
              <div class="row d-flex justify-content-center">
                <action-button
                  v-if="enableDocumentAdd"
                  class="border w-40 btn"
                  i="fas fa-file-plus color-primary-1"
                  text="Presione aquí para anejar documentos"
                  @click="addingDocument = !addingDocument"
                />
              </div>
            </callout>
            <custom-callout
              v-for="(invoiceDocItem, invoiceDocIndex) in invoiceDocuments"
              :key="'invoice-document' + invoiceDocIndex"
              class="mb-3 custom-callout"
              :has-toggle="false"
            >
              <div class="row mx-3">
                <div class="col-md-4 col-sm-12 col-spacing student-spacing">
                  <div class="font-14 color-gray-6">
                    Tipo de Documento:
                  </div>
                  <div class="color-black">
                    {{ invoiceDocItem.documentType }}
                  </div>
                </div>
                <div class="col-md-4 col-sm-12 col-spacing student-spacing">
                  <div class="font-14 color-gray-6">
                    Archivo:
                  </div>
                  <div class="color-black">
                    {{ invoiceDocItem.fileName }}
                  </div>
                </div>
                <div class="col-md-4 mt-3">
                  <drop-down
                    class="d-flex justify-content-end dropdown-doc__extended"
                    :data-item="{
                      value: invoiceDocItem,
                      index: invoiceDocIndex,
                    }"
                    :items="actionItems()"
                  />
                </div>
              </div>
            </custom-callout>
            <div
              v-if="
                invoiceDocuments.length > 0 &&
                  billingDocumentTypes.length > 0 &&
                  !addingDocument &&
                  enableDocumentAdd
              "
              class="col text-right"
            >
              <action-button
                class=""
                i="fas fa-file-plus"
                text="Añadir"
                variant="success"
                @click="addingDocument = !addingDocument"
              />
            </div>
            <custom-callout
              v-if="addingDocument"
              class="mb-3 ml-2 custom-callout"
              :has-toggle="false"
            >
              <validation-observer
                ref="addBillingDocument"
                novalidate
                tag="form"
              >
                <div class="row mx-3">
                  <div class="col-md-4 pt-3 pb-3">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <custom-drop-down
                        v-model="documentModel.type"
                        :clearable="false"
                        custom-error-msg="Favor de seleccionar el tipo el documento."
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        label="Tipo de Documento:"
                        :options="notSelectedDocumentTypes"
                        placeholder="Seleccione"
                      />
                    </validation-provider>
                  </div>
                  <div class="col-md-4 pt-3 pb-3">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <div class="font-14 color-gray-6">
                        Archivo:
                      </div>
                      <div class="font-14 color-black mt-2">
                        <div class="d-flex align-align-items-center">
                          <custom-file-input
                            ref="billinAttachedDocument"
                            v-model="documentModel.selectedDocument"
                            :accept="acceptedExtension"
                            :attachment-id="documentModel.selectedDocumentId"
                            custom-error-msg="Favor de anejar un documento."
                            display-style="normal"
                            :error="errors[0]"
                            required
                          />
                        </div>
                      </div>
                    </validation-provider>
                  </div>
                  <div class="col-md-4 pt-3 pb-3 text-right">
                    <div class="font-14 color-gray-6">
                      <br />
                    </div>
                    <action-button
                      i="fas fa-times-circle"
                      variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
                      @click="
                        () => {
                          clearDocumentModel();
                          addingDocument = !addingDocument;
                        }
                      "
                    >
                      Cancelar
                    </action-button>
                    <action-button
                      :disabled="disableUpload"
                      variant="success pl-4 pr-4"
                      @click="onUploadBillingDocument(documentModel)"
                    >
                      Guardar
                    </action-button>
                  </div>
                </div>
              </validation-observer>
            </custom-callout>
          </custom-tab-item>
          <custom-tab-item
            v-if="!isPreliminar"
            :active="billingInfoTabIndex === billingInfoTabs.ADJUSTMENT"
            lazy
            title="Ajustes"
            @click="onChangeInfoTab(billingInfoTabs.ADJUSTMENT)"
          >
            <div>
              <div class="row px-0 px-md-4 px-sm-0">
                <div class="col">
                  <total-amount-adjustment-view
                    :amount="
                      adjustmentSummary.automaticAdjustmentAmount | price
                    "
                    class="px-3"
                    icon="fa fa-dollar-sign"
                    icon-color="#2db782"
                    :service-total="
                      adjustmentSummary.automaticAdjustmentCount == undefined
                        ? 0
                        : adjustmentSummary.automaticAdjustmentCount
                    "
                    title="Automáticos"
                  />
                  <hr class="d-block d-md-none d-sm-block" />
                </div>
                <div class="col corner-line mt-3 mt-md-0 mt-sm-3">
                  <total-amount-adjustment-view
                    :amount="adjustmentSummary.manualAdjustmentAmount | price"
                    class="px-3"
                    icon="fa fa-dollar-sign"
                    icon-color="#f8b538"
                    :service-total="
                      adjustmentSummary.manualAdjustmentCount == undefined
                        ? 0
                        : adjustmentSummary.manualAdjustmentCount
                    "
                    title="Manuales"
                  />
                  <hr class="d-block d-md-none d-sm-block" />
                </div>
                <div class="col mt-3 mt-md-0 mt-sm-3">
                  <total-amount-adjustment-view
                    :amount="adjustmentSummary.totalAdjustmentAmount | price"
                    class="px-3"
                    icon="fa fa-dollar-sign"
                    icon-color="#b354c4"
                    :service-total="
                      adjustmentSummary.totalAdjustmentCount == undefined
                        ? 0
                        : adjustmentSummary.totalAdjustmentCount
                    "
                    title="Total"
                  />
                </div>
              </div>
              <hr />
              <div class="mt-3">
                <filter-manager
                  ref="filterRef"
                  :filters="filterManagerAdjustmentConfig"
                  :search-text="null"
                  @adjustment="onChangeAdjustment"
                  @objected="onChangeAdjustmentObjected"
                  @sie="onChangeAdjustmentSie"
                  @status="onChangeAdjustmentStatus"
                  @type="onChangeAdjusmentType"
                >
                  <div class="col mt-3 text-right">
                    <br />
                    <action-button
                      i="fa fa-search"
                      text="Buscar"
                      variant="success"
                      @click="onSearchAdjustmentDetail(1)"
                    />
                  </div>
                </filter-manager>
              </div>
              <div class="mt-4">
                <icon-view
                  gradient
                  icon="fa fa-clipboard-list"
                  icon-background="#FF7058"
                  icon-color="#fff"
                  title="Detalle de Ajustes"
                />
              </div>
              <div class="row mt-3">
                <div
                  v-if="billingAdjustmentDetailList.data.length > 0"
                  class="col-md-12"
                >
                  <div
                    v-for="(item, index) in billingAdjustmentDetailList.data"
                    :key="`billing_adjustment_detail_${index}`"
                    class="p-3 bg-secondary-3 rounded mb-3"
                  >
                    <validation-observer
                      ref="billingObjectionFormRef"
                      novalidate
                      tag="form"
                    >
                      <div class="d-flex">
                        <div
                          class="color-black font-16 font-weight-bold flex-grow-1"
                        >
                          {{ item.description }}
                        </div>
                        <div
                          class="font-weight-bold font-16"
                          :class="getAmountColor(item.adjustmentAmt)"
                        >
                          {{ getAdjustmentAmount(item.adjustmentAmt) }}
                        </div>
                        <div
                          v-if="enableBillingAdjustment && canDeleteAdjustment"
                          class="col-md-2 text-right"
                        >
                          <action-button
                            i="fas fa-minus-circle"
                            variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
                            @click="
                              onDeleteGeneralBillingAdjustment(item, index)
                            "
                          >
                            Eliminar
                          </action-button>
                        </div>
                      </div>
                      <hr />
                      <div>
                        <div class="row ml-1">
                          <div class="col-md-2">
                            <div class="color-secondary-6 font-14">
                              Tipo:
                            </div>
                            <div class="color-black font-16 font-weight-normal">
                              {{ item.wasManuallyAddedFlagString }}
                            </div>
                          </div>
                          <div class="col-md-2 mt-3 mt-md-0 mt-sm-3">
                            <div class="color-secondary-6 font-14">
                              Fecha:
                            </div>
                            <div class="color-black font-16 font-weight-normal">
                              {{ item.createDateString }}
                            </div>
                          </div>
                          <div class="col-md-2 mt-3 mt-md-0 mt-sm-3">
                            <div class="color-secondary-6 font-14">
                              Usuario:
                            </div>
                            <div class="color-black font-16 font-weight-normal">
                              {{ item.fullName }}
                            </div>
                          </div>
                          <div class="col-md-6 mt-3 mt-md-0 mt-sm-3 text-right">
                            <action-button
                              v-if="showObjectionButton(item)"
                              :class="{
                                'outline-danger': !item.addNewObjection,
                              }"
                              i="fas fa-gavel"
                              variant="outline-danger mr-2 mt-n0 px-3"
                              @click="onToggleObjectionForm(true, index)"
                            >
                              Objetar
                            </action-button>
                          </div>
                          <div class="col-md-12 mt-2">
                            <div class="color-secondary-6 font-14">
                              Descripción:
                            </div>
                            <div class="color-black font-16 font-weight-normal">
                              {{ getAdjustmentDetailDescription(item) }}
                            </div>
                          </div>
                        </div>
                        <div class="mt-4">
                          <div
                            v-if="item.addNewObjection"
                            class="bg-white bordered px-2 py-2"
                          >
                            <div>
                              <icon-view
                                class="mb-3"
                                icon="fa fa-times-square"
                                icon-background="#fff"
                                icon-color="#FF7058"
                                icon-size="18px"
                                title="Objeción de Ajuste"
                              />
                            </div>
                            <div class="row ml-2 pr-1 mb-3">
                              <div class="col-md-8">
                                <div class="color-secondary-6 font-14">
                                  Comentario:
                                </div>
                                <validation-provider
                                  v-slot="{ errors }"
                                  rules="required"
                                >
                                  <custom-input
                                    v-model="item.objectionModelComment"
                                    custom-error-msg="Favor escribir un comentario."
                                    :error="errors[0]"
                                    :max-length="2000"
                                  />
                                </validation-provider>
                              </div>
                              <div class="col-md-4">
                                <div class="font-14 color-gray-6">
                                  Archivo:
                                </div>
                                <div>
                                  <custom-file-input
                                    ref="billingAdjustmentObjected"
                                    v-model="
                                      item.objectionModelSelectedDocument
                                    "
                                    :accept="'.pdf'"
                                    :attachment-id="item.objectionDocumentId"
                                    display-style="normal"
                                    required
                                  />
                                  <div class="mt-2 text-right">
                                    <action-button
                                      i="fas fa-times-circle"
                                      variant="outline-danger ml-2"
                                      @click="item.addNewObjection = false"
                                    >
                                      Cancelar
                                    </action-button>
                                    <action-button
                                      variant="success ml-2 pl-3"
                                      @click="
                                        saveAdjustmentObjectionHandler(
                                          item,
                                          index
                                        )
                                      "
                                    >
                                      Guardar
                                    </action-button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="
                              !item.addNewObjection && item.objectionStatusId
                            "
                          >
                            <div class="bg-white rounded py-2 pr-3">
                              <div class="row ml-1">
                                <div class="col-md-4">
                                  <div
                                    class="color-black font-16 font-weight-bold"
                                  >
                                    Ajuste Objetado por el Proveedor
                                  </div>
                                </div>
                                <div class="col-md-8 text-right mt-2">
                                  <action-button
                                    v-if="
                                      showResetObjectionButton(item) &&
                                        canReturnToPreviousStatus
                                    "
                                    i="fas fa-undo-alt"
                                    variant="outline-success"
                                    @click="
                                      changeBillingAdjustmentStatusHandler(
                                        item,
                                        getBillingObjectionStatusTypes.Sometida
                                      )
                                    "
                                  >
                                    Regresar Estatus
                                  </action-button>
                                  <action-button
                                    v-if="
                                      showApproveDenyObjectionButton(item) &&
                                        canAcceptObjection
                                    "
                                    i="fas fa-check-square"
                                    variant="outline-success ml-2"
                                    @click="
                                      changeBillingAdjustmentStatusHandler(
                                        item,
                                        getBillingObjectionStatusTypes.Aceptada
                                      )
                                    "
                                  >
                                    Aceptar
                                  </action-button>
                                  <action-button
                                    v-if="
                                      showApproveDenyObjectionButton(item) &&
                                        canRejectObjection
                                    "
                                    i="fas fa-minus-square"
                                    variant="outline-danger ml-2"
                                    @click="
                                      showRejectBillingAdjustmentHandler(item)
                                    "
                                  >
                                    Rechazar
                                  </action-button>
                                  <action-button
                                    v-if="showDeleteObjectionButton(item)"
                                    i="fas fa-times-circle"
                                    variant="outline-danger ml-2"
                                    @click="deleteObjectionHandler(item)"
                                  >
                                    Eliminar
                                  </action-button>
                                  <action-button
                                    v-if="item.objectionDocumentAttachmentId"
                                    i="fas fa-download"
                                    variant="success ml-2 pl-3"
                                    @click="
                                      downloadDocument(
                                        item.objectionDocumentAttachmentId
                                      )
                                    "
                                  />
                                </div>
                              </div>
                              <div class="row mt-2 ml-1">
                                <div class="col-md-2">
                                  <div class="color-secondary-6 font-14">
                                    Fecha:
                                  </div>
                                  <div
                                    class="color-black font-16 font-weight-normal"
                                  >
                                    {{
                                      $formatDate(
                                        item.objectionStatusDate,
                                        $templateDate.default
                                      )
                                    }}
                                  </div>
                                </div>
                                <div class="col-md-2 mt-3 mt-md-0 mt-sm-3">
                                  <div class="color-secondary-6 font-14">
                                    Estatus:
                                  </div>
                                  <div class="color-black font-12">
                                    <em
                                      class="fa fa-circle"
                                      :class="
                                        `color-${getStatusCircleColor(
                                          item.objectionStatusId
                                        )}`
                                      "
                                    />
                                    <span class="font-weight-normal font-16">
                                      {{
                                        getObjectionStatusName(
                                          item.objectionStatusId
                                        )
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="row mt-3 ml-1">
                                <div class="col">
                                  <div class="color-secondary-6 font-14">
                                    Comentario:
                                  </div>
                                  <div
                                    class="color-black font-16 font-weight-normal"
                                  >
                                    {{ item.objectionComment }}
                                  </div>
                                </div>
                              </div>
                              <div
                                v-if="
                                  item.showRejectReason || item.rejectionComment
                                "
                                class="row mt-3 ml-1"
                              >
                                <div class="col-12">
                                  <div class="color-secondary-6 font-14 mb-1">
                                    Razón de Rechazo:
                                  </div>
                                  <div
                                    v-if="item.rejectionComment"
                                    class="color-black font-16 font-weight-normal"
                                  >
                                    {{ item.rejectionComment }}
                                  </div>
                                  <div v-else>
                                    <validation-observer
                                      :ref="`rejectReasonObserver-${index}`"
                                    >
                                      <validation-provider
                                        v-slot="{ errors }"
                                        rules="required"
                                      >
                                        <custom-text-area
                                          v-model="item.modelRejectReason"
                                          custom-error-msg="Favor escribir un comentario."
                                          :error="errors[0]"
                                          :maxlength="3000"
                                          placeholder="Escribe tu comentario"
                                        />
                                      </validation-provider>
                                    </validation-observer>
                                    <div class="text-right mt-2">
                                      <action-button
                                        i="fas fa-times-circle"
                                        variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
                                        @click="
                                          cancelRejectBillingAdjustmentHandler(
                                            item
                                          )
                                        "
                                      >
                                        Cancelar
                                      </action-button>
                                      <action-button
                                        i="fas fa-save"
                                        variant="success pl-4 pr-4"
                                        @click="
                                          saveRejectBillingAdjustmentHandler(
                                            item,
                                            index
                                          )
                                        "
                                      >
                                        Guardar
                                      </action-button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </validation-observer>
                  </div>
                </div>
                <div
                  v-if="
                    billingAdjustmentDetailList.data.length > 0 &&
                      billingAdjustmentDetailList.pagination.totalItemCount > 15
                  "
                  class="col-md-12 text-right"
                >
                  <pagination
                    :data="billingAdjustmentDetailList.pagination"
                    show-text
                    @pagination-go-page="goToPageHandlerAdjustmentDetails"
                  />
                </div>
              </div>
            </div>
          </custom-tab-item>
          <custom-tab-item
            v-if="!isPreliminar"
            :active="billingInfoTabIndex === billingInfoTabs.HISTORY"
            lazy
            title="Historial"
            @click="onChangeInfoTab(billingInfoTabs.HISTORY)"
          >
            <div class="row">
              <div class="col px-0 px-md-5 px-sm-0">
                <time-line class="mt-4">
                  <time-line-item
                    v-for="(item, index) in billingTrackingList"
                    :key="`billing_history_list_${index}`"
                    :icon="getBillingTrackingIcon(item.billingTrackingTypeName)"
                  >
                    <template #date>
                      <span class="color-secondary-6 font-12">Fecha:</span>
                      <p class="color-black font-16 font-weight-bold">
                        {{
                          $formatDate(item.date, $templateDate.longDateWithHour)
                        }}
                      </p>
                    </template>
                    <div id="main-info" class="row">
                      <div class="col additional-evaluation ml-2 mt-1">
                        <div class="color-gray-12 font-18 font-weight-bold">
                          {{ item.billingTrackingTypeName || 'N/A' }}
                        </div>
                      </div>
                      <div class="col mt-3 mt-md-0 mt-sm-3">
                        <div class="color-secondary-6 font-14">
                          Usuario:
                        </div>
                        <div class="color-black font-16 font-weight-normal">
                          {{ item.username }}
                        </div>
                      </div>
                      <div class="col mt-3 mt-md-0 mt-sm-3">
                        <div class="color-secondary-6 font-14">
                          Nombre:
                        </div>
                        <div class="color-black font-16 font-weight-normal">
                          {{ item.userFullName }}
                        </div>
                      </div>
                      <div class="col mt-3 mt-md-0 mt-sm-3">
                        <div class="color-secondary-6 font-14">
                          Estatus:
                        </div>
                        <div class="color-black font-16">
                          <em
                            class="fa fa-circle font-12 mt-1"
                            :class="
                              `color-${getCircleColor(item.billingStatusId)}`
                            "
                          />
                          <span class="font-16 font-weight-normal ml-1">
                            {{ item.billingStatusName }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div v-if="item.trackingComment" class="pt-3">
                      <div class="bg-white p-2 rounded">
                        <div class="row">
                          <div class="col">
                            <em class="fas fa-info-circle color-orange mr-2" />
                            <span class="color-secondary-6 font-14">
                              Descripción:
                            </span>
                          </div>
                        </div>
                        <div class="p-3">
                          <div class="info-panel-item">
                            <div class="font-weight-normal ml-2 pl-1">
                              {{ item.trackingComment }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </time-line-item>
                </time-line>
                <div
                  v-if="
                    visibleShowMoreBillingTracking && billingTracking.length > 5
                  "
                  class="row"
                >
                  <div class="col text-center">
                    <action-button
                      i="fas fa-chevron-down"
                      variant="outline-success custom-view-more"
                      @click="onShowMoreBillingTracking"
                    >
                      Ver más Historial
                    </action-button>
                  </div>
                </div>
              </div>
            </div>
          </custom-tab-item>
          <custom-tab-item
            v-if="showPaymentTab"
            :active="billingInfoTabIndex === billingInfoTabs.PAYMENT"
            lazy
            title="Pago"
            @click="
              () => {
                this.onChangeInfoTab(billingInfoTabs.PAYMENT);
                this.billInfo.isPartialPayment = false;
                this.getPaymentInformation();
              }
            "
          >
            <div>
              <div class="row px-5">
                <div class="col">
                  <div class="d-flex justify-content-end align-items-center">
                    <div style="width: 60px; height: 60px">
                      <circle-loader
                        v-if="paymentPercentage < 100"
                        circle-class="custom-circle-loader"
                        has-icon
                        icon-class="green-color"
                        :percentage="paymentPercentage"
                      >
                        <text
                          :fill="
                            paymentPercentage == 100
                              ? 'background-green #000000'
                              : '#E5F5EF'
                          "
                          font-family="Font Awesome\ 5 Free"
                          font-size="18"
                          x="8"
                          y="25.35"
                        >
                          &#xf00c;
                        </text>
                      </circle-loader>
                      <i
                        v-else
                        class="fas fa-check-circle fa-3x green-color"
                        :class="!isPendingFundsAlert ? 'pt-3 ' : ''"
                      />
                    </div>
                    <div class="ml-2 mt-2">
                      <div class="color-secondary-6 font-14">
                        Monto Total:
                      </div>
                      <div>
                        <div>
                          <span class="color-green font-weight-bold font-22">
                            {{ totalPurchase | price }}
                          </span>
                          /
                          <span class="color-secondary-6 font-16">
                            {{ summaryTotals.total | price }}
                          </span>
                        </div>
                        <div
                          v-if="isPendingFundsAlert && enablePendingFundsAlert"
                        >
                          <em
                            class="fa fa-bell-exclamation color-primary-14 mr-2"
                          />
                          <span class="color-primary-14 font-14">
                            Pendiente de Fondos
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <payment-account-number
                v-if="
                  showPaymentTab &&
                    !billInfo.isPartialPayment &&
                    billInfo.payments.length < 2 &&
                    !hasActiveDebtVoucher
                "
                ref="paymentTab"
                v-model="payment"
                :bill-id="billId"
                :bill-info.sync="billInfo"
                :bill-status="billModel.statusId"
                :bill-total-amount="summaryTotals.total"
                :can-save-voucher-info="canSaveVoucherInfo"
                :contract-info="{
                  contractId: billModel.contractId,
                  isDirectPayment: billModel.isDirectPayment,
                  year: billModel.academicYear,
                }"
                :distribution-info="distributionInfo"
                :purchase-orders="purchaseOrders"
                :show-update-voucher-status="showUpdateVoucherStatus"
                :voucher-tracking-info="billModel.voucherTrackingInfo"
                @add-purchase-order-numbers="onAddPurchaseOrderNumbersHandler"
                @deleteBillingDigit="deleteBillingDigit"
                @on-update-voucher-status="onUpdateVoucherStatusHandler"
                @print-payment-distribution="onPrintPaymentDistribution"
                @refresh-details="refreshPaymentDetails"
                @saveBillingDigit="saveBillingDigit"
              >
                <template v-slot:documents="{ hasPurchaseOrders }">
                  <payment-documents
                    v-if="showPaymentDocuments && hasPurchaseOrders"
                    :bill="billId"
                    :bill-status-id="billModel.statusId"
                    :can-resend-document="!disableEditDocuments(billInfo)"
                    class="mt-3"
                    :disabled="
                      paymentDocumentsReadonly || disableEditDocuments(billInfo)
                    "
                    :is-debt-payment="billPaymentHasDebtPurchaseOrderNumber"
                    :payment-id="paymentId"
                    :voucher-number="payment.voucherNumber"
                  />
                </template>
              </payment-account-number>
              <partial-account-number
                v-if="showPaymentTab && billInfo.isPartialPayment"
                ref="partialTab"
                v-model="payment"
                :bill-id="billId"
                :bill-info.sync="billInfo"
                :bill-status="billModel.statusId"
                :bill-total-amount="summaryTotals.total"
                :can-save-voucher-info="canSaveVoucherInfo"
                class="mt-2"
                :distribution-info="distributionInfo"
                :purchase-orders="purchaseOrders"
                :show-update-voucher-status="showUpdateVoucherStatus"
                @cancelPartialPayment="cancelPayment"
                @deleteBillingDigit="deleteBillingDigit"
                @on-select-purchase-order="onSelectPurchaseOrderHandler"
                @on-update-voucher-status="onUpdateVoucherStatusHandler"
                @print-payment-distribution="onPrintPaymentDistribution"
                @refresh-details="refreshPaymentDetails"
                @saveBillingDigit="saveBillingDigit"
              >
                <template v-slot:documents="{ payment }">
                  <payment-documents
                    v-if="
                      showPaymentDocuments &&
                        Array.isArray(payment.billingPurchaseOrderNumbers) &&
                        payment.billingPurchaseOrderNumbers.length
                    "
                    :bill="billId"
                    :bill-status-id="billModel.statusId"
                    class="mt-3"
                    :disabled="
                      paymentDocumentsReadonly && !!payment.voucherNumber
                    "
                    :is-debt-payment="
                      paymentHasDebtPurchaseOrderNumber(payment)
                    "
                    :payment-id="payment.paymentId"
                    :voucher-number="payment.voucherNumber"
                  />
                </template>
              </partial-account-number>
              <payment-cancelled-account-number
                v-if="showPaymentTab && !billInfo.isPartialPayment"
                ref="paymentCancelledTab"
                v-model="payment"
                :bill-id="billId"
                :bill-info.sync="billInfo"
                :bill-status="billModel.statusId"
                :bill-total-amount="summaryTotals.total"
                :can-save-voucher-info="canSaveVoucherInfo"
                class="mt-2"
                :distribution-info="distributionInfo"
                :purchase-orders="purchaseOrders"
                :show-update-voucher-status="showUpdateVoucherStatus"
                @cancelPayment="cancelPayment"
                @deleteBillingDigit="deleteBillingDigit"
                @on-select-purchase-order="onSelectPurchaseOrderHandler"
                @on-update-voucher-status="onUpdateVoucherStatusHandler"
                @print-payment-distribution="onPrintPaymentDistribution"
                @saveBillingDigit="saveBillingDigit"
              >
                <template v-slot:documents="{ payment }">
                  <payment-documents
                    v-if="
                      showPaymentDocuments &&
                        Array.isArray(payment.billingPurchaseOrderNumbers) &&
                        payment.billingPurchaseOrderNumbers.length
                    "
                    :bill="billId"
                    :bill-status-id="billModel.statusId"
                    class="mt-3"
                    :disabled="
                      paymentDocumentsReadonly && !!payment.voucherNumber
                    "
                    :is-debt-payment="
                      paymentHasDebtPurchaseOrderNumber(payment)
                    "
                    :payment-id="payment.paymentId"
                    :voucher-number="payment.voucherNumber"
                  />
                </template>
              </payment-cancelled-account-number>
            </div>
          </custom-tab-item>
          <custom-tab-item
            v-if="showSifdeTab"
            :active="billingInfoTabIndex === billingInfoTabs.CONTRACT_INFO"
            lazy
            title="Información de Contrato"
            @click="onChangeInfoTab(billingInfoTabs.CONTRACT_INFO)"
          >
            <div class="px-4">
              <ContractAddEdit
                :company-id="companyId"
                :contract-id-value="billModel.contractId"
                read-only
              />
            </div>
          </custom-tab-item>
          <custom-tab-item
            v-if="showJournalTab"
            :active="billingInfoTabIndex === billingInfoTabs.JOURNAL"
            lazy
            title="Bitácora"
            @click="onChangeInfoTab(billingInfoTabs.JOURNAL)"
          >
            <div class="px-4">
              <journal-info :bill-id="billId" />
            </div>
          </custom-tab-item>
        </custom-tab>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import Board from 'Board';
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import CustomTextArea from 'CustomTextArea';
import Error from 'custom-error';
import CustomFileInput from 'CustomFileInput';
import CustomCallout from 'custom-callout';
import CustomRadio from 'custom-radio';
import Pagination from 'pagination';
import DropDown from 'dropdown';
import _generalApi from '@/modules/app/api.js';
import hiringTypes from '@/utils/constants/hiringTypes.js';
import { getSignedDocumentByStudentServiceId as _getSignedDocumentByStudentServiceId } from '@/modules/shared/studentreferral.api.js';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import CustomResultNotFound from 'custom-result-not-found';
import EducativeAdditionalInfo from '@/components/common/visits/EducativeAdditionalInfo';
import voucherStatus from '@/utils/constants/voucherStatus';
import ContractAddEdit from '@/views/provider/management/contract/ContractAddEdit.vue';
import DocumentManagement from '@/views/provider/billingHistory/components/DocumentManagement.vue';
import {
  getBillingDetails,
  updateBillTotals as _updateBillTotals,
  getVisitStudentInfo,
  getBillingDocuments,
  deleteBillingAdjustment,
  deleteBillingDocument,
  uploadBillingDocument,
  updateBillingStatus,
  getDocumentTypes as _getDocumentTypes,
  getCertificationDocumentTypes as _getCertificationDocumentTypes,
  getEvaluationDocument as _getEvaluationDocument,
  getInterventionRevisionDocument as _getInterventionRevisionDocument,
  getBillingAdjustmentSummary as _getBillingAdjustmentSummary,
  submitBillValidation,
  _getPaymentTabInfo,
  _saveBillingPurchaseOrderNumber,
  _saveBillingPurchaseOrderNumberDebt,
  _deleteBillingPurchaseOrderNumber,
  _cancelPayment,
  _hasAdjustmentObjections,
  getBillingAdjustmentList as _getBillingAdjustmentList,
  saveAdjustmentObjection,
  removeBillingAdjustmentComment,
  updateBillingAdjustmentStatus,
  updatePendingFunds,
  getIsPendingFunds,
  getBillingDetailServiceType,
  getBillingDetailDiscipline,
  getBillingDetailSpecialist,
  getBulkDownload,
  getBillingServiceAdjustments as _getBillingServiceAdjustments,
  checkUncheckFlagServiceDetail as _checkUncheckFlagServiceDetail,
  getSifdePurchaseOrders as _getSifdePurchaseOrders,
  getSifdePurchaseOrderNumbers as _getSifdePurchaseOrderNumbers,
  getProjectByCompany as _getProjectByCompany,
  getProjectNumbersByCompany as _getProjectNumbersByCompany,
  getBillingServiceDetails,
  getAdditionalInfo,
  getVisitDetails,
  getEducationalServiceResume as _getEducationalServiceResume,
  getEducationalServiceDetails as _getEducationalServiceDetails,
  updateEducationalServiceMonthlyCost as _updateEducationalServiceMonthlyCost,
  updateEducationalService as _updateEducationalService,
  getEducationalServicesSummary,
  markDocumentDownloaded,
  saveVoucherNumber as _saveVoucherNumber,
} from '@/modules/billingHistory/api';
import { getEvaluationtypes } from '@/modules/shared/code.api.js';
import EvaluationTypes from '@/utils/constants/evaluationTypes.js';

import alert from '@/mixins/alert.mixin';
import loading from '@/mixins/vue-loading';
import billingStatus from '@/utils/constants/billingStatus.js';
import billingAdditionalInformationType from '@/utils/constants/billingAdditionalInformationType.js';
import disciplineTypeCode from '@/utils/constants/disciplineTypeCode.js';
import billingServiceTypes from '@/utils/constants/billingServiceTypes.js';
import billingTrackingTypes from '@/utils/constants/billingTrackingType.js';
import billingObjectionStatusTypes from '@/utils/constants/billingAdjustmentObjectionStatus.js';
import moment from 'moment';
import 'moment/locale/es-do';
import roles from '@/utils/constants/roles.js';
import { serialize as objectToFormData } from 'object-to-formdata';
import { Colors } from '@/components/common';
import { createNamespacedHelpers } from 'vuex';
import { name as moduleName } from '@/modules/billingHistory/store';
import { getBillingServiceCategories as _getBillingServiceCategories } from '@/modules/shared/provideraccountnumber.api.js';
import {
  MUTATION_TYPES,
  ACTION_TYPES,
} from '@/modules/billingHistory/store/types';
const {
  mapMutations,
  mapActions,
  mapState,
  mapGetters,
} = createNamespacedHelpers(moduleName);
import {
  IconView,
  TotalAmountView,
  ServiceTypeView,
  ServiceAlertView,
  ServiceTypeInfoView,
  ServiceTypeEducationalInfoView,
  TotalAmountAdjustmentView,
  PartialAccountNumber,
  PaymentAccountNumber,
  AdditionalPurchaseOrder,
  PaymentCancelledAccountNumber,
  EditDistributionNumber,
  JournalInfo,
  EducativeServiceDocumentManagement,
} from './components';
import TabServiceDetail from './components/tabs/TabServiceDetail.vue';
import TabServiceSummary from './components/tabs/TabServiceSummary.vue';
import PaymentDocuments from './components/PaymentDocuments.vue';
import BillingDistributionDetails from './components/BillingDistributionDetails.vue';
import RetroactivePayments from './components/RetroactivePayments.vue';

import { TimeLine, TimeLineItem } from '@/components/common/timeline';
import CircleLoader from '@/components/common/loaders/CircleLoader';

import storeMixin from 'utils/mixins/storeGenerator';

import visitRegistryApi from '@/modules/visitRegistry/api.js';

import billingLevel from '@/utils/constants/billingLevel.js';
import serviceTypes from '@/utils/constants/serviceTypes.js';
import { updateVoucherBill } from '@/modules/sifdeVendor/api.js';
import thrpyBillingTransactionType from '@/utils/constants/thrpyBillingTransactionType.js';
import _certLoadService from '@/modules/certificationLoad/api.js';
import documentTypes from '@/utils/shared/constants/documentTypes.js';
import billingServiceTypesDetail from '@/utils/constants/billingServiceTypesDetail.js';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';
import sysparameterByNames from '@/utils/constants/sysParameterNames';
import Badge from '@/components/common/Badge.vue';

const BILLING_SERVICE_TABS = {
  ADDITIONAL_INFO: 0,
  VISIT_CERTIFICATION: 1,
  VISIT_DETAILS: 2,
  ADJUSTMENT: 3,
  SERVICE_PROPOSAL: 4,
  SERVICE_DETAILS: 5,
  SERVICE_SUMMARY: 6,
  RETROACTIVE_PAYMENTS: 7,
};

const BILLING_INFO_TABS = {
  SUMMARY: 0,
  DETAIL: 1,
  DOCUMENTS: 2,
  ADJUSTMENT: 3,
  HISTORY: 4,
  PAYMENT: 5,
  CONTRACT_INFO: 6,
  JOURNAL: 7,
};

const StatusPermission = {
  Base: 'provider.billing.history.change.status',
  PendienteAprobacion:
    'provider.billing.history.change.status.pendiente.aprobacion',
  PendientePreAprobacion: 'provider.billing.history.change.status.pre.aprobado',
  Aprobado: 'provider.billing.history.change.status.aprobado',
  EnProcesoIntervencion:
    'provider.billing.history.change.status.proceso.intervencion',
  EnProcesoIntervencionObjetada:
    'provider.billing.history.change.status.proceso.intervencion.objetada',
  EnviadoFinanzasParcial:
    'provider.billing.history.change.status.enviado.finanzas.parcial',
  EnviadoFinanzas: 'provider.billing.history.change.status.enviado.finanzas',
  EnEsperaFondos: 'provider.billing.history.change.status.awaitingfunds',
  EnEsperaAprobacionPO:
    'provider.billing.history.change.status.awaitingpoapproval',
  EnEsperaAsistenciaTecnica:
    'provider.billing.history.change.status.awaitingtechnicalassistance',
  PendienteInformacion:
    'provider.billing.history.change.status.pending.information',
};

//navigation routes
const VISIT_VALIDATION_ROUTE_NAME = 'VisitRegistryValidateFromBilling';
const TRAINING_DETAIL_ROUTE_NAME = 'TrainingDetailsFromBilling';

export default {
  name: 'BillingDetails',
  components: {
    Board,
    IconView,
    PageHeader,
    SectionTitle,
    TotalAmountView,
    ServiceTypeView,
    ServiceAlertView,
    ServiceTypeInfoView,
    ServiceTypeEducationalInfoView,
    CustomDropDown,
    CustomCallout,
    Pagination,
    CustomInput,
    CustomTextArea,
    CustomFileInput,
    CustomRadio,
    Error,
    TotalAmountAdjustmentView,
    TimeLine,
    TimeLineItem,
    CircleLoader,
    PartialAccountNumber,
    PaymentAccountNumber,
    CustomTab,
    CustomTabItem,
    ActionButton,
    DropDown,
    CustomResultNotFound,
    EducativeAdditionalInfo,
    PaymentDocuments,
    AdditionalPurchaseOrder,
    PaymentCancelledAccountNumber,
    DocumentManagement,
    TabServiceDetail,
    TabServiceSummary,
    EditDistributionNumber,
    JournalInfo,
    EducativeServiceDocumentManagement,
    ContractAddEdit,
    BillingDistributionDetails,
    RetroactivePayments,
    Badge,
  },
  mixins: [alert, storeMixin, loading],
  data() {
    return {
      billId: null,
      billModel: null,
      visitDetailsTabIndex: null,
      billingInfoTabIndex: 0,
      infoTabIndex: 0,
      editingDistributionNumber: false,
      summaryTotals: {
        subTotal: null,
        adjustment: null,
        total: null,
      },
      adjustmentSummary: {
        automaticAdjustmentAmount: 0,
        automaticAdjustmentCount: 0,
        manualAdjustmentAmount: 0,
        manualAdjustmentCount: 0,
        totalAdjustmentAmount: 0,
        totaladjustmentCount: 0,
      },
      isPendingFundsAlert: false,
      originalAdjustmentList: [],
      isPreliminar: false,
      alerts: {
        errorVisits: 0,
        noEnded: 0,
        withoutCertification: 0,
      },
      serviceTotals: {
        therapyServiceCount: 0,
        evaluationServiceCount: 0,
        otherServiceCount: 0,
        evaluationServiceAmount: 0,
        therapyServiceAmount: 0,
        otherServiceAmount: 0,
        otherServiceAdjustmentAmount: 0,
      },
      interventionServiceDetail: [],
      evaluationServiceDetail: [],
      educationalServiceDetail: [],
      showInterventionService: false,
      showEducationalServiceResume: false,
      educationalServiceresume: [],
      invoiceDetails: [],
      invoiceDetailsData: {
        fiscalYear: null,
        invoiceNumber: null,
        month: null,
        status: null,
        center: null,
        provider: null,
      },
      interventionServiceInfo: {
        visit: {
          serviceTotal: 0,
          amountTotal: 0,
        },
        admission: {
          serviceTotal: 0,
          amountTotal: 0,
        },
        plan: {
          serviceTotal: 0,
          amountTotal: 0,
        },
      },
      disableUpload: false,
      addingDocument: false,
      documentModel: {
        type: null,
        selectedDocument: null,
        selectedDocumentId: null,
      },
      servicePageIndex: 0,
      invoiceDocuments: [],
      billingDocumentTypes: [],
      billingStatusModel: {
        billStatusId: null,
        comment: '',
      },
      showChangeBillingStatus: false,
      showGeneralAdjustmentForm: false,
      generalAdjustmentModel: {
        amount: null,
        reason: null,
        comment: null,
      },
      visibleShowMoreBillingTracking: true,
      billingTrackingList: [],
      /** Payment */
      payment: {
        paymentId: null,
        purchaseOrderNumber: null,
        purchaseOrderNumberId: null,
        amount: 0,
      },
      billInfo: {
        isPartialPayment: false,
        addDigitForm: false,
        isTryChangeStatus: false,
        //Collections
        billingPurchaseOrderNumbers: [],
        purchaseOrderNumbers: [],
        //For Partial
        payments: [],
        //Calculated
        totalPurchase: 0,
        //Voucher Number & PaymentRefer
        voucherNumber: '',
        checkNumber: '',
        isDirectPayment: false,
        voucherStatus: null,
        purchaseOrderId: null,
        purchaseOrderPk: null,
        paymentId: null,
        voucherTrackingInfo: {},
        selectedPurchaseOrderBudgetYear: null,
      },
      distributionInfo: {
        appointmentDistribution: [],
        planDistribution: [],
        tapRequestDistribution: [],
        visitDistribution: [],
        consultingDistribution: [],
      },
      /** End Payment */
      billingAdjustmentDetailFilter: {
        adjustmentReasonId: null,
        adjustmentType: null,
        objection: null,
        status: null,
        sie: '',
      },
      levelRadioButtons: [],
      adjustmentLevelSelected: null,
      adjustmentQuantity: '',
      adjustmentComment: '',
      adjustmentReasonId: null,
      adjustmentVisit: null,
      itemSelected: null, //Item: Appoitment, Consulting or visit
      pagination: {
        totalItemCount: 0,
        count: 15,
        pageCount: 0,
        currentPage: 1,
        data: [],
      },
      filters: {
        serviceTypes: [],
        evaluationTypes: [],
        disciplineTypes: [],
        specialists: [],
        alerts: [],
      },
      isFederalNumber: null,
      selectedFilters: {
        serviceCategory: null,
        serviceType: null,
        evaluationType: null,
        disciplineType: null,
        specialist: null,
        alert: null,
        sie: '',
        checkedFlag: null,
      },
      appliedFilters: {
        serviceCategory: null,
        serviceType: null,
        evaluationType: null,
        disciplineType: null,
        specialist: null,
        alert: null,
        sie: '',
      },
      validations: {
        voucherNumberRequired: null,
        checkNumberRequired: null,
      },
      isActiveTabPayment: false,
      isActiveTabSummary: true,
      purchaseOrders: [],
      purchaseOrdersByCompany: [],
      projectNumbersInBill: [],
      checkedOptions: [
        { value: true, name: 'Si' },
        { value: false, name: 'No' },
      ],
      certificationDocumentTypes: [],
      selectedPaging: null,
      pageSize: 15,
      canViewBillingAdjustment: false,
      serviceDetail: {
        summaryId: null,
        totalCost: 0,
        services: [],
      },
      servicesSummary: [],
      reportButtons: [
        {
          text: 'Certificación de Servicios Facturados',
          callback: this.getCertificationService,
          permission: 'provider.billing.history.report.servicios.facturados',
        },
        {
          text: 'Excel Master de Servicios',
          callback: this.getExcelMaster,
          permission: 'provider.billing.history.report.master.servicios',
        },
        {
          text: 'Informe de Ajustes',
          callback: this.getAdjustmentReport,
          permission: 'provider.billing.history.report.ajustes',
        },
      ],
      ageGroupList: [],
      showDistribution: false,
    };
  },
  computed: {
    ...mapState({
      billingServiceDetails: (state) => state.billingServiceDetails.data,
      billingStatusList: (state) => state.billingStatusList,
      billingTracking: (state) => state.billingTracking,
      billingAdjustmentDetailList: (state) => state.billingAdjustmentDetailList,
      visits: (state) => state.adjustmentDetails.visits,
    }),
    ...mapGetters({
      reasons: 'getReasons',
    }),
    totalPurchase() {
      return this.billInfo.billingPurchaseOrderNumbers.length > 0
        ? this.billInfo.billingPurchaseOrderNumbers.reduce(
            (sum, item) =>
              sum +
              (item.voucherStatus === voucherStatus.Cancelled
                ? 0
                : item.amount),
            0
          )
        : this.billInfo.payments.reduce(
            (sum, item) =>
              sum +
              (item.voucherStatus === voucherStatus.Cancelled
                ? 0
                : item.purchaseTotal),
            0
          );
    },
    reportButtonAvailables() {
      return this.reportButtons.filter((reportButton) =>
        this.userHasPermissions(reportButton.permission)
      );
    },
    isVisitType() {
      return (item) =>
        [
          thrpyBillingTransactionType.Visit,
          thrpyBillingTransactionType.Educational,
        ].includes(item.transactionType);
    },
    billingLevelEnum() {
      return billingLevel;
    },
    adjustmentListCurrentPage() {
      return this.billingAdjustmentDetailList.pagination.currentPage;
    },
    disableEditDocuments() {
      return (billInfo) =>
        billingStatus.Aprobado == this.billModel?.statusId &&
        !!billInfo.voucherNumber;
    },
    canShowTotalDetail() {
      return billingStatus.Preliminar != this.billModel?.statusId;
    },
    showEvaluationTypeFilter() {
      return (
        this.selectedFilters.serviceType &&
        this.selectedFilters.serviceType.id ===
          billingServiceTypes.EvaluacionAdicional
      );
    },
    isAdminProvider() {
      return [
        roles.AdminProvider,
        roles.AdminProInfo,
        roles.Administrador,
      ].includes(this.userRole);
    },
    enablePendingFundsAlert() {
      return [
        roles.AdminProvider,
        roles.AdminSAEE,
        roles.Administrador,
        roles.InterventorCentro,
      ].includes(this.userRole);
    },
    isInterventorCentro() {
      return [
        roles.InterventorCentro,
        roles.DirectorCentro,
        roles.AuxiliarAdministrativo,
        roles.CentroIsla,
        roles.AdminProvider,
        roles.DirectorAuxiliar,
      ].includes(this.userRole);
    },
    isDirectorCentro() {
      return [
        roles.DirectorCentro,
        roles.CentroIsla,
        roles.AuxiliarAdministrativo,
      ].includes(this.userRole);
    },
    requiredChangeStatusComment() {
      return ![billingStatus.PendienteIntervencionObjetada].includes(
        this.billModel?.statusId
      );
    },
    viewBillingAdjustment() {
      return this.canViewBillingAdjustment;
    },
    canSelectNumberType() {
      return (
        this.canViewBillingAdjustment &&
        this.userHasPermissions('provider.billing.canselectnumbertype')
      );
    },
    enableBillingAdjustment() {
      return [
        billingStatus.EnProcesoIntervencion,
        billingStatus.EnProcesoIntervencionObjetada,
      ].includes(this.billModel?.statusId);
    },
    canDeleteAdjustment() {
      return this.userHasPermissions(
        'provider.billinghistory.adjustment.removeadjustment'
      );
    },
    canAcceptObjection() {
      return this.userHasPermissions(
        'provider.billinghistory.adjustment.acceptobjection'
      );
    },
    canRejectObjection() {
      return this.userHasPermissions(
        'provider.billinghistory.adjustment.rejectobjection'
      );
    },
    canReturnToPreviousStatus() {
      return this.userHasPermissions(
        'provider.billinghistory.adjustment.returntopreviousstatus'
      );
    },
    billingInfoTabIndexValue() {
      return this.billingInfoTabIndex;
    },
    enableChangeBillingStatus() {
      return (
        this.userHasPermissions(StatusPermission.Base) &&
        ![
          billingStatus.Preliminar,
          billingStatus.EnviadoFinanzas,
          billingStatus.Pagado,
        ].includes(this.billModel?.statusId)
      );
    },
    enableDocumentAdd() {
      let canAdd = this.userHasPermissions('billing.document.add');
      if (!canAdd) return false;

      let canAddPreliminarOrPendingInfo = [
        billingStatus.Preliminar,
        billingStatus.PendienteInformacion,
      ].includes(this.billModel?.statusId);
      if (canAddPreliminarOrPendingInfo) {
        return [
          roles.Provider,
          roles.ProviderCPA,
          roles.AdminProvider,
          roles.Administrador,
        ].includes(this.userRole);
      }

      let canAddPendingAprov = [billingStatus.Aprobado].includes(
        this.billModel?.statusId
      );

      if (canAddPendingAprov) {
        return this.userHasPermissions('billing.approval.document.add');
      }

      let canAddPendingApprovalInfo = [
        billingStatus.EnProcesoIntervencionObjetada,
        billingStatus.PendienteAprobacion,
        billingStatus.PendientePreAprobacion,
      ].includes(this.billModel?.statusId);
      if (canAddPendingApprovalInfo) {
        return this.userHasPermissions('billing.pending.approval.document.add');
      }

      if (this.billModel?.statusId == billingStatus.EnviadoFinanzasParcial) {
        return this.userHasPermissions(
          'billing.document.add.enviadofinanzasparcial'
        );
      }
      return false;
    },
    enableSubmitBilling() {
      return (
        !this.isInterventorCentro &&
        [
          billingStatus.Preliminar,
          billingStatus.PendienteInformacion,
          billingStatus.PendienteRevision,
        ].includes(this.billModel?.statusId)
      );
    },
    enabledDocumentTab() {
      //The tab to upload document is visible only if its "Preliminar" or when
      //the user is a provider and the status is "PendienteAprobacion" or "PendienteInformacion"
      return (
        [billingStatus.Preliminar].includes(this.billModel?.statusId) ||
        ([roles.Provider].includes(this.userRole) &&
          [
            billingStatus.PendienteAprobacion,
            billingStatus.PendientePreAprobacion,
            billingStatus.PendienteInformacion,
          ].includes(this.billModel?.statusId))
      );
    },
    isUserProvider() {
      return [roles.Provider].includes(this.userRole);
    },
    serviceAlertTypes() {
      let result = [{ id: 1, name: 'Error en visita' }];
      if (
        [
          roles.InterventorCentro,
          roles.DirectorCentro,
          roles.AuxiliarAdministrativo,
        ].includes(this.userRole)
      ) {
        return result;
      }
      if (this.billModel?.statusId === billingStatus.Preliminar) {
        result.push({ id: 2, name: 'No Finalizados' });
        result.push({ id: 3, name: 'Sin Certificacion de Visita' });
      }
      return result;
    },
    adjustmentTypes() {
      if (!this.billModel) {
        return [];
      }

      const list = [{ id: 0, name: 'Automático' }];
      if (
        (this.billModel.statusId != billingStatus.EnProcesoIntervencion &&
          this.billModel.statusId !=
            billingStatus.EnProcesoIntervencionObjetada) ||
        ((this.billModel.statusId == billingStatus.EnProcesoIntervencion ||
          this.billModel.statusId ==
            billingStatus.EnProcesoIntervencionObjetada) &&
          this.userRole == roles.InterventorCentro)
      ) {
        list.push({ id: 1, name: 'Manual' });
      }

      return list;
    },
    adjustmentList() {
      let adjustments = this.originalAdjustmentList;
      let id = this.billingAdjustmentDetailFilter.adjustmentType;
      if (id == null) {
        return this.originalAdjustmentList;
      }

      let adjustmentDetails = this.billingAdjustmentDetailList.data;
      return adjustments.filter((x) =>
        adjustmentDetails.some(
          (f) =>
            f.adjustmentReasonId == x.id &&
            (id == 1 ? f.wasManuallyAddedFlag : !f.wasManuallyAddedFlag)
        )
      );
    },
    adjustmentObjectedTypes() {
      return [
        { id: 1, name: 'Sí' },
        { id: 0, name: 'No' },
      ];
    },
    adjustmentStatusTypes() {
      return [
        { id: 1, name: 'Sometida' },
        { id: 2, name: 'Aceptada' },
        { id: 3, name: 'Rechazada' },
      ];
    },
    pageHeaderConfig() {
      return {
        title: 'Detalle de Factura',
        icon: 'fas fa-user-tie',
        routes: ['Proveedor', ' Historial de Facturas', 'Detalle'],
      };
    },
    invoiceDetailsBoard() {
      return [
        [
          {
            label: 'Año Fiscal:',
            icon: 'fas fa-calendar-edit',
            data: this.invoiceDetailsData.fiscalYear,
            cols: 'col-4 col-sm col-12',
          },
          {
            label: 'Número Factura:',
            icon: 'fas fa-file-alt',
            data: this.invoiceDetailsData.invoiceNumber,
            cols: 'col-4 col-sm col-12',
          },
          {
            label: 'Mes:',
            icon: 'fas fa-calendar-edit',
            data: this.invoiceDetailsData.month,
            cols: 'col-4 col-sm col-12',
          },
        ],
        [
          {
            label: 'Estatus:',
            icon: 'fas fa-ballot',
            data: this.invoiceDetailsData.status,
            cols: 'col-4 col-sm col-12 mt-3',
          },
          {
            label: 'Centro:',
            icon: 'fas fa-ballot',
            data: this.invoiceDetailsData.center,
            cols: 'col-4 col-sm col-12 mt-3',
          },
          {
            label: 'Proveedor:',
            icon: 'fas fa-address-book',
            data: this.invoiceDetailsData.provider,
            cols: 'col-4 col-sm col-12 mt-3',
          },
        ],
      ];
    },
    toggleServiceClass() {
      return (isOpen) => ({
        'far fa-chevron-circle-right orange-color': !isOpen,
        'far fa-chevron-circle-down green-color': isOpen,
      });
    },
    hasReplaceSpecialistOrLocationService() {
      return (item) => {
        return (
          item.visitSpecialistName &&
          item.locationService &&
          (item.visitSpecialistName.length > 0 ||
            item.locationService.length > 0)
        );
      };
    },
    getVisitDetailsPaginationSize() {
      return 5;
    },
    getLevelOptions() {
      return (type) =>
        this.levelRadioButtons.filter((x) =>
          x.transactionTypeId.includes(type)
        );
    },
    isAdditionalInfoTypeTherapy() {
      return (type) => type === billingAdditionalInformationType.Therapy;
    },
    isAdditionalInfoTypeAppointment() {
      return (type) => type === billingAdditionalInformationType.Appointment;
    },
    isAdditionalInfoTypeConsulting() {
      return (type) => type === billingAdditionalInformationType.Consulting;
    },
    isAdditionalInfoTypeEducationalService() {
      return (type) =>
        type === billingAdditionalInformationType.EducationalService;
    },
    isVisibleMunicipality() {
      return (code) =>
        [
          disciplineTypeCode.Taller,
          disciplineTypeCode.Charla,
          disciplineTypeCode.Compu,
          disciplineTypeCode.ServicioEmergencia,
          disciplineTypeCode.PasajeAereo,
          disciplineTypeCode.PasajeMarino,
        ].includes(code);
    },
    isVisiblePlace() {
      return (code) =>
        [
          disciplineTypeCode.Taller,
          disciplineTypeCode.Charla,
          disciplineTypeCode.Compu,
          disciplineTypeCode.ServicioEmergencia,
          disciplineTypeCode.PasajeAereo,
          disciplineTypeCode.PasajeMarino,
        ].includes(code);
    },
    isVisibleParticipants() {
      return (code) =>
        [disciplineTypeCode.Taller, disciplineTypeCode.Charla].includes(code);
    },
    isVisibleComment() {
      return (code) =>
        [
          disciplineTypeCode.Taller,
          disciplineTypeCode.Charla,
          disciplineTypeCode.Compu,
          disciplineTypeCode.PasajeAereo,
          disciplineTypeCode.PasajeMarino,
        ].includes(code);
    },
    isVisibleService() {
      return (code) => [disciplineTypeCode.ServicioEmergencia].includes(code);
    },
    isEducativeService() {
      return (code) => disciplineTypeCode.ServicioEducativo == code;
    },
    showBillingServiceSie() {
      return (service) =>
        ![
          disciplineTypeCode.Taller,
          disciplineTypeCode.Charla,
          disciplineTypeCode.ServicioEmergencia,
          disciplineTypeCode.PasajeAereo,
          disciplineTypeCode.PasajeMarino,
        ].includes(service?.id);
    },
    showPlanDownload() {
      return (code) => disciplineTypeCode.DiscusionDePlan == code;
    },
    isThrpyService() {
      return (item) =>
        item.serviceTypeId == billingServiceTypes.Terapia &&
        !item.isAdmissionRecord &&
        !item.isInterventionAnnualPackagePlanRecord &&
        !item.isInterventionPlanRecord;
    },

    showBillingServiceAlert() {
      return (service) => service?.id != billingServiceTypes.Consultoria;
    },
    billingServiceTabs() {
      return BILLING_SERVICE_TABS;
    },
    billingInfoTabs() {
      return BILLING_INFO_TABS;
    },
    notSelectedDocumentTypes() {
      return this.billingDocumentTypes.filter(
        (f) =>
          !this.invoiceDocuments.some(
            (s) =>
              s.documentTypeId == f.id &&
              s.documentTypeId != documentTypes.ExcelMaster &&
              s.documentTypeId != documentTypes.PaymentDistribution
          )
      );
    },
    hasEducationEvaluation() {
      return (item) =>
        [
          disciplineTypeCode.Psicoeducativa,
          disciplineTypeCode.PsicoeducativaTwo,
        ].includes(item.disciplineTypeCd) &&
        item.isEducationEvaluationIdentifyCompanies != null &&
        item.hasEducationalEvaluation;
    },
    getBillingTrackingIcon() {
      return (type) => {
        switch (type) {
          case billingTrackingTypes.CambioDeEstatus.name:
            return billingTrackingTypes.CambioDeEstatus.icon;
          case billingTrackingTypes.LogInterface.name:
            return billingTrackingTypes.LogInterface.icon;
          default:
            return billingTrackingTypes.Unset.icon;
        }
      };
    },
    getCircleColor() {
      return (status) => {
        switch (status) {
          case billingStatus.Aprobado:
          case billingStatus.Pagado:
            return Colors.GREEN;
          case billingStatus.EnviadoFinanzas:
            return Colors.CHARDONNAY;
          case billingStatus.Sometida:
          case billingStatus.PendienteIntervencion:
          case billingStatus.PendienteInformacion:
          case billingStatus.PendienteAprobacion:
          case billingStatus.PendientePreAprobacion:
          case billingStatus.PendienteRevision:
          case billingStatus.PendienteIntervencionRevision:
          case billingStatus.EnProcesoIntervencion:
          case billingStatus.EnProcesoDeAjuste:
            return Colors.YELLOW;
          case billingStatus.EnProcesoIntervencionObjetada:
          case billingStatus.PendienteIntervencionObjetada:
            return Colors.VIOLET;
          case billingStatus.Preliminar:
            return Colors.BROWN;
          default:
            return '';
        }
      };
    },
    getStatusCircleColor() {
      return (status) => {
        switch (status) {
          case billingObjectionStatusTypes.Sometida:
            return Colors.YELLOW;
          case billingObjectionStatusTypes.Aceptada:
            return Colors.GREEN;
          case billingObjectionStatusTypes.Rechazada:
            return Colors.RED;
          default:
            return '';
        }
      };
    },
    filterManagerAdjustmentConfig() {
      return [
        {
          name: 'type',
          label: 'Tipo:',
          component: 'CustomDropDown',
          options: this.adjustmentTypes,
          initialValue: null,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-2',
          clearModelsOnUpdate: ['objected', 'status', 'adjustment', 'sie'],
        },
        {
          name: 'objected',
          label: 'Objetado:',
          component: 'CustomDropDown',
          options: this.adjustmentObjectedTypes,
          initialValue: null,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-2',
        },
        {
          name: 'status',
          label: 'Estatus:',
          component: 'CustomDropDown',
          options: this.adjustmentStatusTypes,
          initialValue: null,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-2',
        },
        {
          name: 'adjustment',
          label: 'Ajuste:',
          component: 'CustomDropDown',
          options: this.adjustmentList,
          initialValue: null,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-6',
        },
        {
          name: 'sie',
          component: 'CustomInput',
          class: 'col-md-2',
          label: 'SIE:',
          initialValue: null,
        },
      ];
    },
    getAmountColor() {
      return (amount) => (amount >= 0 ? 'color-primary-1' : 'color-primary-4');
    },
    enableExtraFieldChangeStatus() {
      return (status) =>
        [billingStatus.EnviadoFinanzas, billingStatus.Pagado].includes(
          status?.id
        );
    },
    getAdjustmentDetailDescription() {
      return (item) => {
        let comment = item.comments ?? '';

        if (item.studentFullName && !comment.includes(item.studentFullName)) {
          comment += `. Estudiante: ${item.studentFullName}`;
        }
        if (item.studentSieId && !comment.includes(item.studentSieId)) {
          comment += ` / SIE: ${item.studentSieId}`;
        }
        if (item.referralNumber && !comment.includes(item.referralNumber)) {
          comment += ` / Referido: ${item.referralNumber}`;
        }
        if (
          item.wasManuallyAddedFlagString === 'Manual' &&
          item.visitId &&
          item.visitDate
        ) {
          const date = this.$formatDate(
            item.visitDate,
            this.$templateDate.default
          );
          if (!comment.includes(date)) {
            comment += ` / Día de Visita: ${date}`;
          }
        }
        return comment;
      };
    },
    getAdjustmentAmount() {
      return (amount) => {
        return amount > 0
          ? `+${this.$options.filters.price(amount)}`
          : `-${this.$options.filters.price(Math.abs(amount))}`;
      };
    },
    /** COMPUTED PAYMENT TAB */
    showPartialPaymentTab() {
      if (this.billModel.statusId == billingStatus.PagadoParcial) {
        return false;
      } else {
        return (
          this.billInfo.voucherStatus == voucherStatus.Cancelled ||
          !(this.billInfo.billingPurchaseOrderNumbers?.length > 0)
        );
      }
    },
    paymentPercentage() {
      return (this.totalPurchase / this.summaryTotals.total) * 100;
    },
    paymentId() {
      return this.billInfo.billingPurchaseOrderNumbers[0]?.billingPaymentId;
    },
    paymentDocumentsReadonly() {
      return [
        billingStatus.EnviadoFinanzasParcial,
        billingStatus.EnviadoFinanzas,
        billingStatus.Pagado,
        billingStatus.DevueltoTPFA,
      ].includes(this.billModel?.statusId);
    },
    showPaymentDocuments() {
      return (
        ([billingStatus.Aprobado, billingStatus.DevueltoTPFA].includes(
          this.billModel?.statusId
        ) ||
          this.paymentDocumentsReadonly) &&
        this.userHasPermissions('billing.document.section')
      );
    },
    showPaymentTab() {
      return (
        [
          billingStatus.Pagado,
          billingStatus.PagadoParcial,
          billingStatus.EnviadoFinanzas,
          billingStatus.DevueltoTPFA,
          billingStatus.EnviadoFinanzasParcial,
          billingStatus.EnEsperaFondos,
          billingStatus.EnEsperaAprobacionPO,
          billingStatus.EnEsperaAsistenciaTecnica,
          billingStatus.PendientePreAprobacion,
        ].includes(this.billModel?.statusId) ||
        ([billingStatus.Aprobado, billingStatus.PendienteAprobacion].includes(
          this.billModel?.statusId
        ) &&
          ![roles.Provider, roles.ProviderCPA].includes(this.userRole))
      );
    },
    showSifdeTab() {
      const statusesToShowSIFDE = [
        billingStatus.PendienteAprobacion,
        billingStatus.Aprobado,
        billingStatus.Pagado,
        billingStatus.EnviadoFinanzas,
        billingStatus.EnProcesoIntervencion,
        billingStatus.EnProcesoIntervencionObjetada,
        billingStatus.EnviadoFinanzasParcial,
        billingStatus.PendientePreAprobacion,
        billingStatus.DevueltoTPFA,
        billingStatus.EnEsperaFondos,
        billingStatus.EnEsperaAprobacionPO,
        billingStatus.EnEsperaAsistenciaTecnica,
      ];

      return (
        statusesToShowSIFDE.includes(this.billModel?.statusId) &&
        this.userHasPermissions('billing.detail.sifdeInfo')
      );
    },
    /** END COMPUTED */
    isPendingApprovStatus() {
      return [
        billingStatus.PendienteAprobacion,
        billingStatus.PendientePreAprobacion,
      ].includes(this.billModel?.statusId);
    },
    showObjectionButton() {
      return (item) => {
        return (
          !this.isInterventorCentro &&
          item.objectionFlagFix === false &&
          this.billModel?.statusId === billingStatus.PendienteRevision
        );
      };
    },
    showDeleteObjectionButton() {
      return (item) => {
        return (
          this.userHasPermissions('billing.adjustment.objection.delete') &&
          item.objectionFlagFix === true &&
          this.billModel?.statusId === billingStatus.PendienteRevision
        );
      };
    },
    showApproveDenyObjectionButton() {
      return (item) => {
        return (
          this.userHasPermissions(
            'billing.adjustment.objection.changestatus'
          ) &&
          item.objectionStatusIdFix === billingObjectionStatusTypes.Sometida &&
          this.billModel?.statusId ===
            billingStatus.EnProcesoIntervencionObjetada
        );
      };
    },
    showResetObjectionButton() {
      return (item) => {
        return (
          this.userHasPermissions(
            'billing.adjustment.objection.changestatus'
          ) &&
          item.objectionStatusIdFix !== billingObjectionStatusTypes.Sometida &&
          this.billModel?.statusId ===
            billingStatus.EnProcesoIntervencionObjetada
        );
      };
    },

    getBillingObjectionStatusTypes() {
      return billingObjectionStatusTypes;
    },
    getObjectionStatusName() {
      return (status) => {
        switch (status) {
          case billingObjectionStatusTypes.Aceptada:
            return 'Aceptado';
          case billingObjectionStatusTypes.Rechazada:
            return 'Rechazado';
          default:
            return 'Sometido';
        }
      };
    },
    enablePaymentProof() {
      if (this.billInfo.isPartialPayment) {
        return [
          billingStatus.Aprobado,
          billingStatus.EnviadoFinanzas,
          billingStatus.PagadoParcial,
          billingStatus.EnviadoFinanzasParcial,
        ].includes(this.billModel?.statusId);
      } else {
        return [
          billingStatus.Aprobado,
          billingStatus.EnviadoFinanzas,
          billingStatus.Pagado,
        ].includes(this.billModel?.statusId);
      }
    },
    enableCheckNumberField() {
      return [
        billingStatus.EnviadoFinanzasParcial,
        billingStatus.EnviadoFinanzas,
      ].includes(this.billModel?.statusId);
    },
    enableVoucherField() {
      return [billingStatus.Aprobado, billingStatus.PagadoParcial].includes(
        this.billModel?.statusId
      );
    },
    enableVoucherFieldReadOnly() {
      return [
        billingStatus.EnviadoFinanzas,
        billingStatus.Pagado,
        billingStatus.EnviadoFinanzasParcial,
        billingStatus.PagadoParcial,
      ].includes(this.billModel?.statusId);
    },
    enableCheckNumberFieldReadOnly() {
      return [billingStatus.Pagado].includes(this.billModel?.statusId);
    },

    setFormatOrEmpty() {
      return (value, filterName) =>
        value ? this.$options.filters[filterName](value) : '-';
    },
    canDoPendingFunds() {
      return (
        this.isActiveTabPayment &&
        !this.isPendingFundsAlert &&
        this.enablePendingFundsAlert &&
        [
          billingStatus.Aprobado,
          billingStatus.EnviadoFinanzas,
          billingStatus.EnviadoFinanzasParcial,
        ].includes(this.billModel.statusId)
      );
    },
    canDoPartialPayment() {
      return (
        this.isActiveTabPayment &&
        this.showPaymentTab &&
        this.showPartialPaymentTab &&
        [
          billingStatus.Aprobado,
          billingStatus.DevueltoTPFA,
          billingStatus.PendienteAprobacion,
        ].includes(this.billModel.statusId)
      );
    },
    hasActiveDebtVoucher() {
      return (this.billInfo.payments || []).some((p) => p.isDebtVoucher);
    },
    hasDebtPurchaseOrderNumber() {
      return (this.billInfo.billingPurchaseOrderNumbers || []).some(
        (d) => d.hiringType === hiringTypes.debt
      );
    },
    billPaymentHasDebtPurchaseOrderNumber() {
      return (this.billInfo?.billingPurchaseOrderNumbers || []).some(
        (d) => d.hiringType === hiringTypes.debt
      );
    },
    paymentHasDebtPurchaseOrderNumber() {
      return (payment) =>
        (payment?.billingPurchaseOrderNumbers || []).some(
          (d) => d.hiringType === hiringTypes.debt
        );
    },
    canSaveVoucherInfo() {
      return (
        (this.billInfo.isDirectPayment || this.hasDebtPurchaseOrderNumber) &&
        [
          billingStatus.EnviadoFinanzas,
          billingStatus.EnviadoFinanzasParcial,
        ].includes(this.billModel?.statusId) &&
        this.isActiveTabPayment
      );
    },
    canViewVisitDate() {
      return (item) =>
        this.adjustmentLevelSelected?.value !== -1 &&
        (item.transactionType === billingLevel.visit ||
          item.transactionType === billingLevel.educational);
    },
    showUpdateVoucherStatus() {
      return (
        this.userHasPermissions('billing.detail.updatevoucherstatus') &&
        [
          billingStatus.EnviadoFinanzas,
          billingStatus.Pagado,
          billingStatus.EnviadoFinanzasParcial,
          billingStatus.DevueltoTPFA,
        ].includes(this.billModel?.statusId)
      );
    },
    editVisitTitle() {
      return (item) =>
        item.transactionType === billingLevel.appointment
          ? 'Ver Detalle'
          : 'Editar Visita';
    },
    canEditVist() {
      return (item) =>
        [
          billingLevel.visit,
          billingLevel.appointment,
          billingLevel.educational,
        ].includes(item.transactionType);
    },
    showInterventionFilter() {
      return (
        this.isInterventorCentro &&
        [billingStatus.EnProcesoIntervencion].includes(this.billModel?.statusId)
      );
    },
    isAppoved() {
      return this.billModel.statusId == billingStatus.Aprobado;
    },
    billingStatusListAvailable() {
      if (!this.userHasPermissions(StatusPermission.Base)) return [];

      if (this.isAppoved && this.billInfo.isPartialPayment) {
        return this.userHasPermissions(StatusPermission.EnviadoFinanzasParcial)
          ? this.billingStatusList.filter(
              (x) => x.id == billingStatus.EnviadoFinanzasParcial
            )
          : [];
      }

      const statusToPrevious = [
        billingStatus.EnEsperaAprobacionPO,
        billingStatus.EnEsperaAsistenciaTecnica,
        billingStatus.EnEsperaFondos,
      ];

      if (statusToPrevious.includes(this.billModel?.statusId)) {
        return this.billingStatusList;
      }

      var statusToRemove = [];
      if (!this.userHasPermissions(StatusPermission.Aprobado)) {
        statusToRemove.push(billingStatus.Aprobado);
      }

      if (!this.userHasPermissions(StatusPermission.EnProcesoIntervencion)) {
        statusToRemove.push(billingStatus.EnProcesoIntervencion);
      }

      if (
        !this.userHasPermissions(StatusPermission.EnProcesoIntervencionObjetada)
      ) {
        statusToRemove.push(billingStatus.EnProcesoIntervencionObjetada);
      }

      if (!this.userHasPermissions(StatusPermission.PendientePreAprobacion)) {
        statusToRemove.push(billingStatus.PendientePreAprobacion);
      }

      if (!this.userHasPermissions(StatusPermission.PendienteAprobacion)) {
        statusToRemove.push(billingStatus.PendienteAprobacion);
      }

      if (!this.userHasPermissions(StatusPermission.EnviadoFinanzasParcial)) {
        statusToRemove.push(billingStatus.EnviadoFinanzasParcial);
      }

      if (!this.userHasPermissions(StatusPermission.EnviadoFinanzas)) {
        statusToRemove.push(billingStatus.EnviadoFinanzas);
      }

      if (!this.userHasPermissions(StatusPermission.EnEsperaFondos)) {
        statusToRemove.push(billingStatus.EnEsperaFondos);
      }

      if (!this.userHasPermissions(StatusPermission.EnEsperaAprobacionPO)) {
        statusToRemove.push(billingStatus.EnEsperaAprobacionPO);
      }

      if (
        !this.userHasPermissions(StatusPermission.EnEsperaAsistenciaTecnica)
      ) {
        statusToRemove.push(billingStatus.EnEsperaAsistenciaTecnica);
      }

      if (!this.userHasPermissions(StatusPermission.PendienteInformacion)) {
        statusToRemove.push(billingStatus.PendienteInformacion);
      }

      return this.billingStatusList.filter(
        (x) => !statusToRemove.includes(x.id)
      );
    },
    acceptedExtension() {
      return this.documentModel.type?.id == documentTypes.ExcelMaster
        ? '.xlsx'
        : '.pdf';
    },
    pagingList() {
      return [
        {
          id: 15,
          name: 15,
        },
        {
          id: 20,
          name: 20,
        },
        {
          id: 25,
          name: 25,
        },
        {
          id: 30,
          name: 30,
        },
      ];
    },
    canMarkAllAsIntervened() {
      return (
        this.enableBillingAdjustment &&
        this.userHasPermissions('billing.detail.mark.all.intervened')
      );
    },
    canDownloadMassCertifications() {
      return (
        this.enableBillingAdjustment &&
        this.userHasPermissions('billing.detail.download.mass.certifications')
      );
    },
    canEditDistributionNumber() {
      return (
        [
          billingStatus.EnProcesoIntervencion,
          billingStatus.EnProcesoIntervencionObjetada,
          billingStatus.EnviadoFinanzasParcial,
          billingStatus.DevueltoTPFA,
          billingStatus.Aprobado,
        ].includes(this.billModel?.statusId) &&
        this.userHasPermissions('provider.billing.editdistributionnumber')
      );
    },
    canMarkAsIntervened() {
      return this.userHasPermissions('billing.detail.mark.intervened');
    },
    canDownloadDocument() {
      return this.userHasPermissions('billing.detail.download.document');
    },
    canDoAjustToBill() {
      return this.userHasPermissions('billing.detail.do.ajust.bill');
    },
    canAjustBill() {
      return (
        this.enableBillingAdjustment &&
        this.userHasPermissions('billing.detail.ajust.bill')
      );
    },
    showJournalTab() {
      return (
        ![
          billingStatus.Preliminar,
          billingStatus.Sometida,
          billingStatus.EnProcesoDeAjuste,
        ].includes(this.billModel?.statusId) &&
        this.userHasPermissions('provider.billing.view.journaltab')
      );
    },
    numberTypeOptions() {
      return [
        {
          id: 1,
          name: 'numberType-rbnt',
          value: true,
          label: 'Federal',
          check: false,
          invalid: false,
          disabled: false,
        },
        {
          id: 2,
          name: 'numberType-rbnt',
          value: false,
          label: 'Estatal',
          check: false,
          invalid: false,
          disabled: false,
        },
      ];
    },
    getAdditionalInfoIdByTransactionType() {
      return (item) =>
        item.transactionType ==
        billingAdditionalInformationType.EducationalService
          ? item.tapRequestId
          : item.id;
    },
    companyId() {
      return this.billModel?.companyId;
    },
    showDistributionButton() {
      return (
        !this.showDistribution &&
        this.billModel?.statusId !== billingStatus.Preliminar &&
        this.billModel?.statusId !== billingStatus.PendienteIntervencion &&
        this.userHasPermissions(
          'provider.billing.history.distribution.details.view'
        )
      );
    },
  },
  watch: {
    'billingStatusModel.billStatusId'(newValue) {
      this.billingStatusModel.comment = '';
      if (!newValue) return;

      const status = this.billingStatusListAvailable.find(
        (status) => status.id == newValue.id
      );

      const validForPrevious = [
        billingStatus.EnEsperaFondos,
        billingStatus.EnEsperaAprobacionPO,
        billingStatus.EnEsperaAsistenciaTecnica,
      ];

      let comment = `La factura ha sido cambiada a {STATUS} por {ROLE}.`;

      if (validForPrevious.includes(this.billModel.statusId)) {
        comment = `La factura ha sido cambiada al estatus anterior {STATUS} por {ROLE}.`;
      }

      this.billingStatusModel.comment = comment
        .replace('{STATUS}', status.name)
        .replace('{ROLE}', this.userRole);
    },
  },
  async mounted() {
    //set default paging
    this.billId = parseInt(this.$route.params.billId);
    await this.getParameters();

    if (!this.moduleData[this.$options.name]) {
      await this.getDetailsInfo();
    }

    if (!this.selectedPaging) {
      this.selectedPaging = this.pagingList.find((x) => x.id == this.pageSize);
    }
    this.onChangeInfoTab(
      this.$route.params.tabIndex || this.billingInfoTabs.SUMMARY
    );
    this.loadLevelOptions();
    this.getAgeGroup();
    this.onChangeBillingDisciplineType();
  },
  methods: {
    async refreshPaymentDetails() {
      await Promise.all([this.getDetailsInfo(), this.getPaymentInformation()]);
    },
    async getParameters() {
      const { data: sysParameters } = await _getSysparameterByNames({
        parameterNames: [sysparameterByNames.EnableBillingAdjustmentStatus],
      });
      this.sysParameters = sysParameters;
    },
    validateViewBillingAdjustment() {
      var status = this.getSysParemeterStaticValue(
        sysparameterByNames.EnableBillingAdjustmentStatus
      );

      if (status == null) {
        return;
      }
      this.canViewBillingAdjustment =
        this.userHasPermissions('provider.billing.viewnumber') &&
        status.split(',').includes(this.billModel?.statusId.toString());
    },
    getSysParemeterStaticValue(parameterName) {
      if (!this.sysParameters) {
        return null;
      }

      return (this.sysParameters.find((x) => x.name === parameterName) || {})
        .staticValue;
    },
    getTransactionName(type) {
      switch (type.transactionTypeId) {
        case billingLevel.visit:
          return type.visitId ? 'Visita' : 'Resumen';
        case billingLevel.appointment:
          return 'Cita';
        case billingLevel.consulting:
          return 'Consultoría';
        case billingLevel.educational:
          return 'Servicio';
        default:
          return 'N/A';
      }
    },
    actionItems() {
      return [
        {
          name: 'download',
          label: 'Descargar',
          icon: 'fa fa-file-download text-green pr-2',
          click: ({ value }) => {
            this.downloadDocument(value.id);
          },
        },
        {
          name: 'delete',
          label: 'Eliminar',
          icon: 'fa fa-times-circle text-danger pr-2',
          visible: ({ value }) => this.canDeleteDocument(value),
          click: ({ value }) => {
            this.deleteDocument(value.id);
          },
        },
      ];
    },
    loadLevelOptions() {
      this.levelRadioButtons = [
        {
          label: 'Visita',
          value: billingLevel.visit,
          transactionTypeId: [billingLevel.visit],
        },
        {
          label: 'Resumen',
          value: -1,
          transactionTypeId: [
            billingLevel.visit,
            billingLevel.appointment,
            billingLevel.educational,
          ],
        },
        {
          label: 'Consultoría',
          value: billingLevel.consulting,
          transactionTypeId: [billingLevel.consulting],
        },
        {
          label: 'Servicio',
          value: billingLevel.educational,
          transactionTypeId: [billingLevel.educational],
        },
      ];
    },
    openEducationalServiceTab(itemIndex) {
      this.setResultOpen(itemIndex);
      this.visitDetailsTabIndex = this.visitDetailsTabIndex =
        BILLING_SERVICE_TABS.SERVICE_DETAILS;
    },
    async getEducationalServiceDetails(summaryId) {
      const { data: response } = await _getEducationalServiceDetails(summaryId);
      if (response) {
        this.serviceDetail = response;
      }
    },
    async getEducationalServiceResume() {
      const { data: response } = await _getEducationalServiceResume(
        this.billId
      );
      if (response) {
        this.educationalServiceresume = response.filter((s) => {
          return s.serviceTypeId != 1 && s.serviceTypeId != 3;
        });
        this.educationalServiceDetail = response
          .filter((s) => {
            return s.serviceTypeId == 1 || s.serviceTypeId == 3;
          })
          .map((x) => {
            return {
              label: x.serviceTypeName,
              value: x.serviceTotalAmount,
              amount: x.serviceCount,
              total: x.total,
              type: billingServiceTypesDetail.Detail,
            };
          });
      }
    },
    async getEducationalServicesSumarry(requestId) {
      const { data: response } = await getEducationalServicesSummary(requestId);
      if (response) {
        this.servicesSummary = response;
      }
    },
    async updateEducationalService(rowItem, service, isRemoving = false) {
      service.isSelected = !isRemoving;
      service.isRemoving = isRemoving;
      service.billId = this.billModel.billId;
      const { data: response } = await _updateEducationalService(service).catch(
        (error) => {
          this.ShowToast('', error.response.data.message, 'error');
          service.isSelected = isRemoving;
          return;
        }
      );
      if (response) {
        this.serviceDetail = response;
        rowItem.educationServiceCostAmount = response.totalCost;
      }
    },
    canDeleteDocument(document) {
      switch (this.billModel?.statusId) {
        case billingStatus.Preliminar:
          return this.userHasPermissions('billing.document.delete.preliminar');
        case billingStatus.PendienteInformacion:
          return this.userHasPermissions(
            'billing.document.delete.pendienteinformacion'
          );
        case billingStatus.PendienteAprobacion:
        case billingStatus.PendientePreAprobacion:
          return (
            this.userHasPermissions(
              'billing.document.delete.pendienteaprobacion'
            ) &&
            [documentTypes.CseeCertification].includes(document.documentTypeId)
          );
        case billingStatus.Aprobado:
          return (
            this.userHasPermissions('billing.document.delete.aprobado') &&
            [
              documentTypes.ExcelMaster,
              documentTypes.PaymentDistribution,
              documentTypes.MixedServicesCertification,
            ].includes(document.documentTypeId)
          );
        case billingStatus.EnviadoFinanzasParcial:
          return [
            documentTypes.ExcelMaster,
            documentTypes.PaymentDistribution,
            documentTypes.MixedervicesCertification,
          ].includes(document.documentTypeId);
        default:
          return false;
      }
    },
    ...mapActions([
      ACTION_TYPES.GET_BILLING_SERVICE_DETAILS,
      ACTION_TYPES.GET_VISIT_DETAILS,
      ACTION_TYPES.GET_BILLING_ADDITIONAL_INFO,
      ACTION_TYPES.UPLOAD_VISIT_CERT_DOCUMENT,
      ACTION_TYPES.GET_BILLING_ADJUSTMENTS_DETAILS,
      ACTION_TYPES.GET_BILLING_STATUS_TRANSITION,
      ACTION_TYPES.GET_BILLING_DETAILS_SERVICE_TYPE,
      ACTION_TYPES.GET_BILLING_DETAILS_DISCIPLINE,
      ACTION_TYPES.GET_BILLING_DETAILS_SPECIALIST,
      ACTION_TYPES.CHECK_UNCHECK_FLAG_SERVICE_DETAIL,
      ACTION_TYPES.GET_BILLING_TRACKING,
      ACTION_TYPES.GET_BILLING_ADJUSTMENTS_DETAILS_LIST,
      ACTION_TYPES.GET_REASONS,
      ACTION_TYPES.SAVE_ADJUSTMENT,
      ACTION_TYPES.GET_BILLING_SERVICE_ADJUSTMENTS,
    ]),
    ...mapMutations([
      MUTATION_TYPES.SET_BILLING_SERVICE_DETAILS_INFO,
      MUTATION_TYPES.SET_BILLING_FILTER,
      MUTATION_TYPES.SET_CATALOG,
      MUTATION_TYPES.SET_BILLING_ADJUSTMENT_OBJECTION,
      MUTATION_TYPES.SET_SERVICE_ADJUSTMENT_PAGING,
    ]),
    ...mapGetters(['getCostbyReasonId']),
    isEvaluationService(item) {
      return (
        item.serviceTypeId == billingServiceTypes.EvaluacionInicial ||
        item.serviceTypeId == billingServiceTypes.EvaluacionAdicional
      );
    },
    isConsultingService(item) {
      return item.serviceTypeId == billingServiceTypes.Consultoria;
    },
    showRetroactivePaymentsTab(item) {
      return (
        item.transactionType ===
          billingAdditionalInformationType.EducationalService &&
        item.hasRetroactivePaymentAuthorization !== null &&
        item.hasRetroactivePaymentAuthorization !== undefined
      );
    },
    getRetroactivePaymentsDetails(item) {
      return {
        ...item,
        ...(item.details || {}),
      };
    },
    async onChangeToAdittionalInfo(item, itemIndex, tabIndex) {
      if (itemIndex !== undefined) {
        this.setResultOpen(itemIndex);
      }

      const { data: detailResponse } = await getAdditionalInfo(
        item.transactionType,
        this.getAdditionalInfoIdByTransactionType(item)
      );
      this.$set(item, 'details', {
        ...item.details,
        ...detailResponse,
      });

      this.visitDetailsTabIndex =
        tabIndex ?? BILLING_SERVICE_TABS.ADDITIONAL_INFO;
    },
    async onChangeInfoTab(tabIndex) {
      this.$nextTick(async () => {
        this.billingInfoTabIndex = tabIndex;

        if (this.billingInfoTabIndex === BILLING_INFO_TABS.DETAIL) {
          this[MUTATION_TYPES.SET_BILLING_FILTER]({
            serviceType: null,
            discipline: null,
            specialist: null,
            alert: null,
            sie: '',
          });

          await this.onSearchBillingServiceHandler();
          await this.getPurchaseOrdersByCompany();
          await this.getProjectNumbersInBill();
          await this.callGetEvaluationtypes();
          await this.callGetBillingDetailSpecialist();

          if (this.filters.serviceTypes.length == 0) {
            await this.callGetBillingDetailServiceType();
          }
        }

        if (this.billingInfoTabIndex === BILLING_INFO_TABS.HISTORY) {
          this.callGetBillingTracking(this.billId);
          this.visibleShowMoreBillingTracking = true;
        }

        if (this.billingInfoTabIndex === BILLING_INFO_TABS.ADJUSTMENT) {
          this.getAdjustmentSummary();
          this.callGetBillingAdjusmentDetails(this.billId);
        }

        this.isActiveTabPayment =
          this.billingInfoTabIndex === BILLING_INFO_TABS.PAYMENT;

        this.isActiveTabSummary =
          this.billingInfoTabIndex === BILLING_INFO_TABS.SUMMARY;
      });
    },
    async getDetailsInfo() {
      const res = await getBillingDetails(this.billId);
      let data = res.data;
      this.billModel = res.data;
      this.distributionInfo = res.data.distributionInfo;
      this.isPreliminar = res.data.statusId == billingStatus.Preliminar;

      //Datos generales
      this.invoiceDetailsData.fiscalYear = data.academicYearDescription;
      this.invoiceDetailsData.invoiceNumber = data.billNumber;
      this.invoiceDetailsData.month = this.getMonthDescription(
        data.monthNumber,
        data.academicYearDescription
      );
      this.invoiceDetailsData.status = data.statusDescription;
      this.invoiceDetailsData.center = data.centerName;
      this.invoiceDetailsData.provider = data.companyName;
      this.invoiceDetailsData.monthNumber = data.monthNumber;
      this.invoiceDetailsData.academicYear = data.academicYear;
      this.invoiceDetailsData.academicYearId = data.academicYearId;
      this.invoiceDetailsData.academicYearStartDate =
        data.academicYearStartDate;
      this.invoiceDetailsData.academicYearEndDate = data.academicYearEndDate;
      this.invoiceDetailsData.academicYearDescription =
        data.academicYearDescription;

      //Resumen totales
      this.summaryTotals.subTotal = data.totalServiceCostAmount;
      this.summaryTotals.adjustment = data.totalAdjustmentAmount;
      this.summaryTotals.total = data.totalBillAmount;

      //Alertas
      this.alerts.errorVisits = data.errorVisitAlerts;
      this.alerts.noEnded = data.notEndedAlerts;
      this.alerts.withoutCertification = data.withoutCertificationVisitAlerts;

      //Totales de Servicios
      this.serviceTotals = data.serviceTotalSummary;

      //Totals in collapse
      (this.interventionServiceInfo = {
        visit: {
          serviceTotal: data.serviceTotalSummary.visitServiceCount,
          amountTotal: data.serviceTotalSummary.visitServiceAmount,
        },
        admission: {
          serviceTotal: data.serviceTotalSummary.admissionServiceCount,
          amountTotal: data.serviceTotalSummary.admissionServiceAmount,
        },
        plan: {
          serviceTotal: data.serviceTotalSummary.planServiceCount,
          amountTotal: data.serviceTotalSummary.planServiceAmount,
        },
      }),
        //Services Details
        (this.interventionServiceDetail = data.interventionServiceSummary.map(
          (x) => {
            return {
              label: x.serviceCategoryName,
              value: x.serviceTotal,
              total: x.total,
            };
          }
        ));
      this.evaluationServiceDetail = data.evaluationServiceSummary.map((x) => ({
        label: x.serviceCategoryName,
        value: x.serviceTotal,
        total: x.total,
      }));
      await this.getEducationalServiceResume();
      await _updateEducationalServiceMonthlyCost(this.billId);
      await this.getIsPendingFunds();
      this.validateViewBillingAdjustment();
    },
    async onUploadBillingDocument(item) {
      const isValid = await this.$refs.addBillingDocument.validate();
      if (!isValid) {
        this.ShowToast(
          '',
          'Favor, debe completar los campos para continuar.',
          'error'
        );
        return;
      }

      this.disableUpload = true;
      let formData = new FormData();
      formData.append('file', item.selectedDocument);

      await uploadBillingDocument(
        this.billId,
        this.documentModel.type?.id,
        formData
      )
        .then(() => {
          this.ShowToast(
            '',
            'El archivo ha sido cargado exitosamente.',
            'success'
          );
          this.getBillingDocuments();
          this.clearDocumentModel();
          this.addingDocument = false;
        })
        .catch(() => this.ShowToast('', 'Error al subir el archivo.', 'error'));

      this.disableUpload = false;
    },
    async getDocumentTypes() {
      await _getDocumentTypes(this.billId)
        .then((res) => {
          this.billingDocumentTypes = res.data;
        })
        .catch(() => {});
    },
    async updateBillTotals(showMessage = true) {
      try {
        const { data: result } = await _updateBillTotals(this.billId);
        if (result) {
          await this.getDetailsInfo();
          if (showMessage) {
            this.ShowToast(
              '',
              'La factura fue actualizada exitosamente.',
              'success'
            );
          }
        }
      } catch (error) {
        this.ShowToast('', error.response.data.message, 'error');
      }
    },
    async getBillingDocuments() {
      await getBillingDocuments(this.billId)
        .then((res) => (this.invoiceDocuments = res.data))
        .catch(() => {
          this.ShowToast('', 'Error al obtener datos.', 'error');
        });

      await this.getDocumentTypes();
      this.addingDocument = false;

      this.clearDocumentModel();
    },
    async evaluateDownload(item) {
      if (item.documentId) {
        await this.downloadDocument(item.documentId, true);
      } else if (item.peiAtServiceId) {
        await this.onEvaluationAppointmentDownload(item, true);
      } else if (this.showPlanDownload(item.disciplineTypeCd))
        await this.onPlanInterventionRevisionDownload(item);
    },
    async downloadDocument(documentId, sendMark = false) {
      if (documentId) {
        await _generalApi
          .downloadDocumentByAttachmentId(documentId)
          .then(() => {
            if (sendMark) {
              markDocumentDownloaded(this.billId);
            }
          })
          .catch(() => {
            this.ShowToast('', 'El documento no existe.', 'error');
          });
      }
    },
    async downloadConsultingDocument(consultingId) {
      if (consultingId) {
        await _generalApi.downloadConsultingDocument(consultingId).catch(() => {
          this.ShowToast('', 'El documento no existe.', 'error');
        });
      }
    },
    clearDocumentModel() {
      this.documentModel = {
        type: null,
        selectedDocument: null,
        selectedDocumentId: null,
      };
    },
    emptyText(value) {
      return value == null || value == '' ? '-' : value;
    },
    async deleteDocument(documentId) {
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar el documento seleccionado?',
        'Si',
        'No'
      );
      if (answer) {
        await deleteBillingDocument(documentId)
          .then(() =>
            this.ShowToast('', 'Documento eliminado exitosamente', 'success')
          )
          .catch(() =>
            this.ShowToast(
              '',
              'No ha sido posible eliminar el documento seleccionado.',
              'error'
            )
          );
        await this.getBillingDocuments();
      }
    },
    onToggleServiceInfo() {
      this.showInterventionService = !this.showInterventionService;
    },
    async onToggleServiceAdditionalInfo(item) {
      //Set the current item status
      item.isOpen = item.isOpen != undefined ? !item.isOpen : true;

      //Close all the opened records
      for (let i = 0; i < this.pagination.data.length; i++) {
        if (this.pagination.data[i] != item)
          this.pagination.data[i].isOpen = false;
      }

      if (item.isOpen) {
        const { data: detailResponse } = await getAdditionalInfo(
          item.transactionType,
          this.getAdditionalInfoIdByTransactionType(item)
        );
        item.details = {
          ...item.details,
          ...detailResponse,
          billingAdjustmentDetails: {},
        };
      }

      this.visitDetailsTabIndex = BILLING_SERVICE_TABS.ADDITIONAL_INFO;

      await this.$forceUpdate();
    },
    async setCurrentDetailPage(page) {
      await this.getBillServiceDetails(page, {
        categoryId: this.appliedFilters.serviceCategory?.id ?? null,
        serviceId: this.appliedFilters.serviceType?.id ?? null,
        evaluationTypeId: this.appliedFilters.evaluationType?.id ?? null,
        disciplineId: this.appliedFilters.disciplineType?.id ?? null,
        specialistId: this.appliedFilters.specialist?.id ?? null,
        alertId: this.appliedFilters.alert?.id ?? null,
        studentSieId: this.appliedFilters.sie,
        checkedFlag: this.appliedFilters.checkedFlag?.value ?? null,
        pageSize: this.pageSize,
      });
    },
    goToPageHandlerVisitDetails(page, item, itemIndex) {
      this.getVisitDetailList(item, {
        visitSummaryId: item.id,
        disciplineTypeId: item.disciplineTypeCd,
        itemIndex: itemIndex,
        pageIndex: page,
        pageSize: this.getVisitDetailsPaginationSize,
      });
    },
    async getErrorVisit() {
      let academicYearId = this.billModel.academicYearId,
        monthNumber = this.billModel.monthNumber,
        companyId = this.billModel.companyId,
        centerId = this.billModel.centerId,
        billId = this.billId;
      let report = `alertWithVisitErrors/${academicYearId}/${monthNumber}/${companyId}/${centerId}/${billId}`;
      await _generalApi.downloadReport(report);
    },
    async getWithouFinish() {
      let report = `alertwithoutfinish/${this.billId}`;
      await _generalApi.downloadReport(report);
    },
    async getWithoutCertification() {
      let report = `alertswithoutcertification/${this.billId}`;
      await _generalApi.downloadReport(report);
    },
    getMonthDescription(monthNumber, year) {
      let yearDesc = monthNumber > 6 ? year.split('-')[0] : year.split('-')[1];
      let monthDesc = moment()
        .set({ month: monthNumber - 1 })
        .format('MMMM')
        .replace(/\b\w/g, (l) => l.toUpperCase());
      return monthDesc + ' ' + yearDesc;
    },
    async openServiceProposal(item, itemIndex) {
      this.setResultOpen(itemIndex);
      this.visitDetailsTabIndex = BILLING_SERVICE_TABS.SERVICE_PROPOSAL;
    },
    async openCertificationVisit(item, itemIndex) {
      const { data } = await _certLoadService.getDocumentTypes();
      this.certificationDocumentTypes = [...data];

      item.certDocument = {
        documentType: this.certificationDocumentTypes.find(
          (d) => d.id == documentTypes.VisitCertification
        ),
        details: item.details,
        selectedDocument: null,
        documentId: item.documentId,
        documentName: item.studentSieId.toString(),
      };

      this.setResultOpen(itemIndex);
      this.visitDetailsTabIndex = BILLING_SERVICE_TABS.VISIT_CERTIFICATION;
    },
    async getCertificationDocumentTypes() {
      await _getCertificationDocumentTypes()
        .then(({ data }) => {
          this.certificationDocumentTypes = data;
        })
        .catch(() => {});
    },
    async certVisitUploadDocument(item, itemIndex) {
      if (this.$refs.submitCertDocRef) {
        const isValid = await this.$refs.submitCertDocRef[0].validate();
        if (!isValid) {
          this.ShowToast('Alerta', 'Información Incompleta', 'error');
        } else {
          const { academicYearId, monthNumber } = this.invoiceDetailsData;
          const params = {
            academicYearId: academicYearId,
            companyId: item.companyId,
            month: monthNumber,
            centerId: item.serviceCenterId,
            disciplineTypeId: item.disciplineTypeCd,
            serviceId: item.serviceTypeId,
            specialistId: item.specialistId,
            studentSieId: item.studentSieId,
            documentTypeId: item.certDocument?.documentType?.id,
            visitSummaryId: item.id,
          };

          const formData = objectToFormData(
            {
              ...params,
              files: item.certDocument?.selectedDocument,
            },
            {
              indices: true,
              nullsAsUndefineds: true,
            }
          );

          const payload = {
            formData,
            search: params,
          };

          const uploadResult = await this[
            ACTION_TYPES.UPLOAD_VISIT_CERT_DOCUMENT
          ](payload);
          this.$refs.submitCertDocRef[0].reset();
          this.ShowWait();
          if (uploadResult.errorMessages.length > 0) {
            this.HideWait();
            const errorMessage = uploadResult.errorMessages[0].description;
            if (!errorMessage.includes('servicios del Especialista')) {
              this.ShowToast(
                'Error',
                uploadResult.errorMessages[0].description,
                'error'
              );
            } else {
              this.ShowToast(
                'Error',
                'El documento debe nombrarse igual que el SIE.',
                'error'
              );
            }
          } else {
            this.openCertificationVisit(item, itemIndex); //Close first later serch again
            this.servicePageIndex =
              this.servicePageIndex == 0 ? 1 : this.servicePageIndex;
            await this.setCurrentDetailPage(this.servicePageIndex);
            this.HideWait();
            this.ShowToast(
              'Proceso Exitoso',
              'El documento ha sido cargado exitosamente.',
              'success'
            );
          }
        }
      }
    },
    async getCertificationService() {
      let report = `billcertificationservice/${this.billId}`;
      await _generalApi.downloadReport(report);
    },
    async getExcelMaster() {
      let report = `excelmaster/${this.billId}`;
      await _generalApi.downloadReport(report);
    },
    async getAdjustmentReport() {
      let report = `invoiceadjustment/${this.billId}`;
      await _generalApi.downloadReport(report);
    },
    async getBillServiceDetails(pageIndex, payload) {
      await getBillingServiceDetails({
        billId: this.billId,
        pageIndex,
        currentPage: pageIndex,
        ...payload,
      }).then((resp) => {
        this.pagination = {
          pageSize: this.pageSize,
          ...resp.data,
        };
        this.onToggleNumberType();
      });
    },
    async getVisitDetailList(item, payload) {
      const { data: visitResult } = await getVisitDetails(payload);
      item.details = {
        ...item.details,
        visitDetailsList: {
          data: visitResult.data,
          pagination: {
            count: visitResult.count,
            currentPage: visitResult.currentPage,
            pageCount: visitResult.pageCount,
            totalItemCount: visitResult.totalItemCount,
          },
        },
      };
      await this.$forceUpdate();
    },
    async editVisitHandler(item) {
      if (item.serviceTypeId === serviceTypes.Consultancy) {
        //validate is period is finalized
        const {
          data: finalizeResponse,
        } = await visitRegistryApi.isFinalizedPeriod(
          academicYearId,
          moment()
            .set({ month: this.invoiceDetailsData.monthNumber - 1 })
            .toDate(),
          item.specialistId,
          item.companyId,
          item.serviceCenterId
        );

        this.$router.push({
          name: TRAINING_DETAIL_ROUTE_NAME,
          params: {
            id: item.id,
            isEditMode: !finalizeResponse,
          },
        });
        return;
      }

      const {
        academicYearId,
        monthNumber,
        month,
        academicYearStartDate,
        academicYearDescription,
      } = this.invoiceDetailsData;
      const { data: studentInfo } = await getVisitStudentInfo(
        item.studentServiceId,
        academicYearId,
        month,
        item.admissionId
      );
      const currentPeriodYear = moment(academicYearStartDate).year();

      await this.$router.push({
        name: VISIT_VALIDATION_ROUTE_NAME,
        params: {
          ...item,
          ...studentInfo,
          id: item.studentServiceId,
          academicYearId: academicYearId,
          visitStudentServiceId: item.studentServiceId,
          specialistId: item.specialistId,
          companyId: item.companyId,
          centerId: item.serviceCenterId,
          disciplineTypeId: item.disciplineTypeCd,
          serviceDate: month,
          initialPeriodInfo: {
            year: currentPeriodYear,
            monthNumber: monthNumber,
          },
          currentPeriod: {
            year: parseInt(
              monthNumber > 6
                ? academicYearDescription.split('-')[0]
                : academicYearDescription.split('-')[1]
            ),
            monthNumber: monthNumber,
          },
          disabledPeriods: [],

          from: 'BillingDetails',
          fromData: {
            billId: this.$route.params.billId,
            tabIndex: this.billingInfoTabs.DETAIL,
          },
        },
      });
    },
    getDatesBetween(startDate, endDate) {
      const result = [];
      while (startDate.isBefore(endDate)) {
        result.push(startDate.format());
        startDate.add(1, 'month');
      }
      return result;
    },
    async onDownloadServiceDocument({ documentId }) {
      if (documentId) {
        await _generalApi
          .downloadDocumentByAttachmentId(documentId)
          .catch(() => {
            this.ShowToast('', 'El documento no existe.', 'error');
          });
      }
    },
    async onDownload(documentId) {
      if (documentId) {
        await _generalApi
          .downloadDocumentByAttachmentId(documentId)
          .catch(() => {
            this.ShowToast('', 'El documento no existe.', 'error');
          });
      }
    },
    async onEvaluationAppointmentDownload(item, sendMark = false) {
      await _getEvaluationDocument(item.id, item.peiAtServiceId)
        .then((response) => {
          _generalApi.ConvertToBlob(response.data);
          if (sendMark) {
            markDocumentDownloaded(this.billId);
          }
        })
        .catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
    },
    async onPlanInterventionRevisionDownload(item) {
      await _getInterventionRevisionDocument(item.id, item.planId)
        .then((response) => {
          _generalApi.ConvertToBlob(response.data);
        })
        .catch(() => {
          this.ShowToast('', 'El documento no existe.', 'error');
        });
    },
    async printInterventionPlan(item) {
      let report = `referral/interventionplanreport/${item.admissionId}/${item.planId}`;
      await _generalApi.downloadReport(report);
    },
    ViewPlanHandler(item) {
      this.$router.push({
        name: 'interventionPlan',
        params: {
          admissionId: item.admissionId,
          academicYearId: item.planAcademicYearId,
          interventionPlanId: item.planId,
          onlyShowPlan: '1',
          from: 'BillingDetails',
          fromData: {
            billId: this.$route.params.billId,
            tabIndex: this.billingInfoTabs.DETAIL,
          },
        },
      });
    },
    getBillingAdjustment(item, itemIndex) {
      this[ACTION_TYPES.GET_BILLING_ADJUSTMENTS_DETAILS]({
        itemIndex,
        id: item.billId,
      });
    },
    async getBillStatusList() {
      const { statusId, billId } = this.billModel;
      this[ACTION_TYPES.GET_BILLING_STATUS_TRANSITION]({
        statusId,
        billId,
      });
    },
    async callGetEvaluationtypes() {
      const { data } = await getEvaluationtypes();

      this.filters.evaluationTypes = data.filter((x) =>
        [
          EvaluationTypes.Evaluación_Adicional,
          EvaluationTypes.Evaluación_Trianual,
          EvaluationTypes.Reevaluacion,
        ].includes(x.id)
      );
    },
    async callGetBillingDetailServiceType() {
      const { billId } = this.billModel;
      if (billId) {
        await getBillingDetailServiceType(billId).then((resp) => {
          this.filters.serviceTypes = resp.data;
        });
      }
    },
    async callGetBillingDetailDiscipline(serviceTypeId) {
      const { billId } = this.billModel;
      if (billId) {
        await getBillingDetailDiscipline(billId, serviceTypeId).then((resp) => {
          this.filters.disciplineTypes = resp.data;
        });
      }
    },
    async callGetBillingDetailSpecialist(disciplineTypeId) {
      const { billId } = this.billModel;
      if (billId) {
        const { data } = await getBillingDetailSpecialist(
          billId,
          disciplineTypeId
        );
        this.filters.specialists = data;
      }
    },
    async onChangeBillingStatusForm() {
      if (!this.showChangeBillingStatus) {
        this.showChangeBillingStatus = true;
        this.showGeneralAdjustmentForm = false;
        this.billingStatusModel = {
          ...this.billingStatusModel,
          billStatusId: null,
          comment: null,
        };
        await this.getBillStatusList();
      }
    },
    async onBillingAdjustmentForm() {
      this[ACTION_TYPES.GET_REASONS]({
        billId: this.billId,
        id: this.itemSelected?.id,
        typeId: parseInt(this.adjustmentLevelSelected?.value),
      });

      if (this.showGeneralAdjustmentForm) {
        this.generalAdjustmentModel.amount = null;
        this.generalAdjustmentModel.reason = null;
        this.generalAdjustmentModel.comment = null;

        this.showGeneralAdjustmentForm = false;
        return;
      }

      this.showGeneralAdjustmentForm = true;
      this.showChangeBillingStatus = false;
    },
    async onChangeBillingStatusHandler() {
      const isValid = await this.$refs.submitUpdateBillingStatusRef.validate();

      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      const { billId } = this.billModel;
      let newStatusId = this.billingStatusModel.billStatusId?.id;

      if (newStatusId == billingStatus.EnviadoFinanzas) {
        this.billingInfoTabIndex = BILLING_INFO_TABS.PAYMENT;
        await this.$nextTick();
        await this.getPaymentInformation();

        if (this.billModel.isDirectPayment) {
          const result = await this.saveVoucherNumber();

          if (!result) {
            return;
          }
        }

        if (
          Math.round(this.totalPurchase * 100) !==
          Math.round(this.summaryTotals.total * 100)
        ) {
          this.ShowToast(
            '',
            'El monto debe igualar al balance total de la factura.',
            'error'
          );
          return;
        }
      }

      let userConfirmation =
        newStatusId == billingStatus.PendienteAprobacion
          ? await this.ShowCancelModal(
              'Atención',
              `Certifico haber realizado el proceso de intervención de la factura ${this.invoiceDetailsData.invoiceNumber} para su debida aprobación en sistema.`,
              'Si',
              'No'
            )
          : true;

      if (!userConfirmation) {
        return;
      }

      const { data: updateResult } = await updateBillingStatus({
        billId,
        billStatusId: this.billingStatusModel.billStatusId?.id ?? null,
        comment: this.billingStatusModel.comment,
        voucher: this.billingStatusModel.voucher,
        checkNumber: this.billingStatusModel.checkNumber,
      });

      if (!updateResult.isValid) {
        this.ShowToast('', updateResult.message, 'error');
        return;
      }

      this.ShowToast(
        'Proceso Exitoso.',
        'El estatus fue cambiado exitosamente.',
        'success'
      );
      this.onCancelBillingStatusHandler();
      await this.getDetailsInfo();
      await this.getPaymentInformation();
      await this.getBillingDocuments();

      //ECG:Necesito esperar por que se recargue la factura para tomar el vouchernumber recien generado
      if (
        newStatusId == billingStatus.EnviadoFinanzas &&
        this.billModel.statusId == billingStatus.EnviadoFinanzas
      ) {
        //ECG:solo si la intencion era cambiar a EnviadoFinanzas y realmente se logro
        await updateVoucherBill(updateResult.voucherNumber, billId);
        await this.getDetailsInfo();
      }
    },
    onCancelBillingStatusHandler() {
      this.showChangeBillingStatus = false;
      this.billingStatusModel = {};
    },
    setResultOpen(itemIndex) {
      this.pagination = {
        ...this.pagination,
        data: this.pagination.data.map((item, index) => {
          return {
            ...item,
            isOpen: itemIndex === index,
          };
        }),
      };
    },
    async saveVoucherNumber() {
      const voucherNumberValid = await this.$refs.paymentTab.$refs.voucherNumberRef.validate();
      const voucherDateValid = await this.$refs.paymentTab.$refs.voucherDateRef.validate();

      if (!voucherNumberValid || !voucherDateValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return false;
      }

      const payload = {
        billId: this.billId,
        voucherNumber: this.$refs.paymentTab.voucherNumber,
        voucherDate: this.billInfo.voucherDate,
        paymentId: this.billInfo.paymentId,
      };

      try {
        const response = await _saveVoucherNumber(payload);

        if (response.data) {
          this.ShowToast('', 'Voucher guardado exitosamente.', 'success');
        }

        return true;
      } catch (error) {
        this.ShowToast('', 'Error al guardar el voucher.', 'error');
        return false;
      }
    },
    async viewVisitDetailHandler(item, itemIndex) {
      await this.getVisitDetailList(item, {
        visitSummaryId: item.id,
        disciplineTypeId: item.disciplineTypeCd,
        itemIndex: itemIndex,
        pageIndex: 1,
        pageSize: this.getVisitDetailsPaginationSize,
      });

      this.setResultOpen(itemIndex);
      this.visitDetailsTabIndex = BILLING_SERVICE_TABS.VISIT_DETAILS;
    },
    onChangeBillingServiceType(value) {
      this.filters.disciplineTypes = [];
      this.selectedFilters.disciplineType = null;

      if (value?.id) {
        this.callGetBillingDetailDiscipline(value?.id);
        if (value?.id == billingServiceTypes.Consultoria) {
          this.selectedFilters.alert = null;
        }
      }
    },
    onChangeBillingDisciplineType(value) {
      this.filters.specialists = [];
      this.selectedFilters.specialist = null;
      // US62439 - show all specialist by contract, but can also filter if user selected a discipline
      this.callGetBillingDetailSpecialist(value?.id ?? 0);
    },
    async onSearchBillingServiceHandler() {
      this.appliedFilters = Object.assign({}, this.selectedFilters);

      await this.getBillServiceDetails(1, {
        categoryId: this.appliedFilters.serviceCategory?.id ?? null,
        serviceId: this.appliedFilters.serviceType?.id ?? null,
        evaluationTypeId: this.appliedFilters.evaluationType?.id ?? null,
        disciplineId: this.appliedFilters.disciplineType?.id ?? null,
        specialistId: this.appliedFilters.specialist?.id ?? null,
        alertId: this.appliedFilters.alert?.id ?? null,
        studentSieId: this.appliedFilters.sie,
        checkedFlag: this.appliedFilters.checkedFlag?.value ?? null,
        pageSize: this.pageSize,
      });
    },
    async onSubmitBill() {
      const { billId, billNumber, statusId } = this.billModel;

      if (this.isPreliminar) {
        const oldTotals = { ...this.summaryTotals };
        await this.updateBillTotals(false);

        const totalsChanged =
          this.summaryTotals.adjustment !== oldTotals.adjustment ||
          this.summaryTotals.subTotal !== oldTotals.subTotal ||
          this.summaryTotals.total !== oldTotals.total;

        if (totalsChanged) {
          const message = `Hubo un cambio en el monto de la factura, ¿está seguro(a) que desea Someter la factura ${billNumber}?`;
          let confirm = await this.ShowCancelModal(
            'Atención',
            message,
            'Si',
            'No'
          );
          if (!confirm) return;
        }
      }

      if (billId) {
        //Status pendiente Revisión
        //Valida si tiene ajustes objetados y muestra mensaje de confirmación
        if (statusId == billingStatus.PendienteRevision) {
          let hasObjections = await _hasAdjustmentObjections({ billId });
          if (!hasObjections) {
            let answerObjection = await this.ShowCancelModal(
              'Atención',
              '¿Está seguro que desea someter sin objetar los ajustes de la factura?',
              'Si',
              'No'
            );
            if (!answerObjection) {
              return;
            }
          }
        }

        const { data: validations } = await submitBillValidation(billId);
        let isValid = true;
        let warningMessage = null;
        if (validations?.length > 0) {
          validations.forEach((item) => {
            if (!item.isValid && item.extraInfo == null) {
              this.Toast('Alerta', item.message, 'error', 10000);
              isValid = false;
            } else if (!item.isValid && item.extraInfo == 'warning') {
              warningMessage = item.message;
            }
          });
        }

        if (warningMessage != null) {
          const answer = await this.ShowCancelModal(
            'Atención',
            warningMessage,
            'Si',
            'No'
          );
          if (answer) {
            await submitBillValidation(billId, true);
            this.ShowToast(
              'Proceso Exitoso.',
              'El estatus fue cambiado exitosamente.',
              'success'
            );
            await this.getDetailsInfo();
          }
        } else if (isValid) {
          this.ShowToast(
            'Proceso Exitoso.',
            'El estatus fue cambiado exitosamente.',
            'success'
          );
          await this.getDetailsInfo();
        }
      }
    },
    async checkUncheckService(item, index) {
      //Validate
      let isValid = true;
      if (!item.checkedFlag) {
        //Validate if is checked = true [For false is not need]
        isValid = await this.$refs.purchaseOrders[index].validate();
      }
      if (isValid) {
        const payload = [
          {
            id: item.id,
            tableToCkFlag: item.transactionType,
            checked: !item.checkedFlag,
            purchaseOrderId:
              item.purchaseOrder !== undefined && item.purchaseOrder !== null
                ? item.purchaseOrder?.id
                : 0,
          },
        ];

        const pageIndex = this.pagination.currentPage;

        item.checkedFlag = !item.checkedFlag;
        await _checkUncheckFlagServiceDetail(payload);

        await this.getProjectNumbersInBill();

        this.appliedFilters = Object.assign({}, this.selectedFilters);
        await this.getBillServiceDetails(pageIndex, {
          categoryId: this.appliedFilters.serviceCategory?.id ?? null,
          serviceId: this.appliedFilters.serviceType?.id ?? null,
          evaluationTypeId: this.appliedFilters.evaluationType?.id ?? null,
          disciplineId: this.appliedFilters.disciplineType?.id ?? null,
          specialistId: this.appliedFilters.specialist?.id ?? null,
          alertId: this.appliedFilters.alert?.id ?? null,
          studentSieId: this.appliedFilters.sie,
          checkedFlag: this.appliedFilters.checkedFlag?.value ?? null,
          pageSize: this.pageSize,
        });
      }
    },
    async markAllService() {
      if (this.pagination.data.length > 0) {
        //Execute all validations when try to mark all services
        let isValid = true;
        for (var index in this.pagination.data) {
          let isPurchaseOrderSelected = await this.$refs.purchaseOrders[
            index
          ].validate();
          if (isPurchaseOrderSelected == false) {
            isValid = false;
          }
        }
        if (isValid) {
          const payload = this.pagination.data
            .filter((x) => !x.checkedFlag)
            .map((item) => ({
              id: item.id,
              tableToCkFlag: item.transactionType,
              checked: true,
              purchaseOrderId: item.purchaseOrder?.id,
            }));

          if (payload.length > 0) {
            await _checkUncheckFlagServiceDetail(payload);
            await this.getProjectNumbersInBill();
            this.pagination = {
              ...this.pagination,
              data: this.pagination.data.map((item) => ({
                ...item,
                checkedFlag: true,
              })),
            };
          }
        }
      }
    },
    async bulkDownload() {
      this.appliedFilters = Object.assign({}, this.selectedFilters);

      const pageIndex = this.pagination.currentPage;

      try {
        const response = await getBulkDownload({
          billId: this.billId,
          pageIndex,
          pageSize: this.pageSize,
          currentPage: pageIndex,
          serviceId: this.appliedFilters.serviceType?.id ?? null,
          disciplineId: this.appliedFilters.disciplineType?.id ?? null,
          specialistId: this.appliedFilters.specialist?.id ?? null,
          alertId: this.appliedFilters.alert?.id ?? null,
          studentSieId: this.appliedFilters.sie,
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Facturas.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        if (error.response?.data?.message) {
          this.ShowToast('', error.response.data.message, 'error');
        } else {
          this.ShowToast('', 'Error al descargar el archivo', 'error');
        }
      }
    },
    async setDistributionNumberFlag(edit = true) {
      this.editingDistributionNumber = edit;
    },
    async onUpdateDistributionNumber() {
      this.setDistributionNumberFlag(false);
      this.onSearchBillingServiceHandler();
      await this.getProjectNumbersInBill();
    },
    async getPurchaseOrdersByCompany() {
      this.purchaseOrdersByCompany = (
        await _getProjectByCompany(this.billModel.billId)
      ).data;
    },
    async getProjectNumbersInBill() {
      this.projectNumbersInBill = (
        await _getProjectNumbersByCompany(this.billModel.billId)
      ).data;
    },
    onShowMoreBillingTracking() {
      this.billingTrackingList = this.billingTracking;
      this.visibleShowMoreBillingTracking = false;
    },
    async saveAdjustmentObjectionHandler(item, itemIndex) {
      const isValid = await this.$refs.billingObjectionFormRef[
        itemIndex
      ].validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      let formData = objectToFormData(
        {
          visitBillingAdjustmentId: item.visitBillingAdjustmentId,
          comment: item.objectionModelComment,
          files: item.objectionModelSelectedDocument,
        },
        { indices: true, nullsAsUndefineds: true }
      );

      const { data: objectionResult } = await saveAdjustmentObjection(formData);
      if (objectionResult) {
        this.onSearchAdjustmentDetail(this.adjustmentListCurrentPage);
        this.ShowToast(
          'Proceso Exitoso',
          'El ajuste fue objetado exitosamente.',
          'success'
        );
      }
    },
    //PAYMENT TAB
    //************************************************** */
    async getPaymentInformation() {
      this.billInfo.payments = []; //Reset
      this.billInfo.billingPurchaseOrderNumbers = []; //Reset
      if (this.payment == null) {
        this.payment = {
          paymentId: null,
          purchaseOrderNumber: null,
          purchaseOrderNumberId: null,
          amount: 0,
        };
      }

      this.purchaseOrders = (
        await _getSifdePurchaseOrders(this.billModel.companyId, this.billId)
      ).data;

      await _getPaymentTabInfo(this.billId)
        .then(async (res) => {
          this.billInfo.selectedPurchaseOrderId = null;
          //If exist partialPayment is true
          if (res.data.some((s) => s.isPartial)) {
            this.billInfo.payments = res.data;
            this.billInfo.isPartialPayment = true;

            //Set Last Voucher Numer
            this.billInfo.voucherNumber =
              res.data[res.data.length - 1].voucherNumber;
            this.billInfo.checkNumber =
              res.data[res.data.length - 1].paymentIdReference;
            this.billInfo.paymentId = res.data[res.data.length - 1].paymentId;

            for (const p of this.billInfo.payments) {
              if (p.purchaseOrderPk) {
                await this.onAddPurchaseOrderNumbersHandler(p.purchaseOrderPk);
              }
            }
          } else if (res.data[0] != undefined) {
            const paymentInfo = res.data[0];
            //Set Bill Information
            if (res.data.length > 1) {
              this.billInfo.payments = res.data;
            }

            this.billInfo.isPartialPayment = false;
            this.billInfo.purchaseOrderPk = paymentInfo.purchaseOrderPk;
            this.billInfo.paymentId = paymentInfo.paymentId;
            this.billInfo.paymentIdReference = paymentInfo.paymentIdReference;
            this.billInfo.billingPurchaseOrderNumbers =
              paymentInfo.billingPurchaseOrderNumbers;
            this.billInfo.voucherNumber = paymentInfo.voucherNumber;
            this.billInfo.isDirectPayment =
              paymentInfo.isDirectPayment ?? false;

            this.$set(
              this.billInfo,
              'voucherDate',
              paymentInfo.voucherDate != null
                ? new Date(paymentInfo.voucherDate)
                : this.billInfo.voucherDate
            );
            this.$set(
              this.billInfo,
              'paymentDate',
              paymentInfo.paymentDate != null
                ? new Date(paymentInfo.paymentDate)
                : null
            );
            this.billInfo.voucherStatus = paymentInfo.voucherStatus;
            this.billInfo.checkNumber = paymentInfo.paymentIdReference;
            this.billInfo.selectedPurchaseOrderId = paymentInfo.purchaseOrderId;
            this.billInfo.selectedPurchaseOrderBudgetYear =
              paymentInfo.purchaseOrderBudgetYear;

            if (this.billInfo.selectedPurchaseOrderPk) {
              await this.onAddPurchaseOrderNumbersHandler(
                this.billInfo.selectedPurchaseOrderPk
              );
            }
          } else if (this.billInfo.isPartialPayment == null) {
            this.billInfo.isPartialPayment = false; //For default
          } else if (
            this.billInfo.payments.every((p) => p.purchaseTotal != 0)
          ) {
            this.billInfo.payments = [];
          }
        })
        .catch((e) =>
          this.ShowToast(
            '',
            'Error al obtener los datos, detalles: ' + e.message,
            'error'
          )
        );
    },
    //Save
    async saveBillingDigit() {
      let saveModel = {
        billId: this.billId,
        PurchaseOrderNumberId:
          typeof this.payment.purchaseOrderNumber?.id === 'string'
            ? Number(this.payment.purchaseOrderNumber?.id.split('-')[0])
            : this.payment.purchaseOrderNumber?.id,
        amount: this.payment.amount,
        isPartial: this.billInfo.isPartialPayment,
        paymentId: this.billInfo.isPartialPayment
          ? this.payment.paymentId
          : null,
        purchaseOrderId: this.payment.purchaseOrderId?.poNumber,
        purchaseOrderBudgetYear: parseInt(this.payment.purchaseOrderId?.year),
        lineNumber: this.payment.lineNumber,
      };
      const isDebtVoucher = this.payment.isDebtVoucher;
      if (isDebtVoucher) {
        saveModel = {
          ...saveModel,
          voucherNumber: this.payment.voucherNumber,
          voucherDate: this.payment.voucherDate,
          paymentNumber: this.payment.paymentNumber,
          paymentDate: this.payment.paymentDate,
        };
      }
      const saveRequest = isDebtVoucher
        ? _saveBillingPurchaseOrderNumberDebt(saveModel)
        : _saveBillingPurchaseOrderNumber(saveModel);
      await saveRequest
        .then(({ data }) => {
          if (data.isValid) {
            this.ShowToast(
              '',
              'El Número de cifra agregado exitosamente.',
              'success'
            );
            this.getPaymentInformation();
            this.clearBillingPayments();
            this.billInfo.addDigitForm = false;
            if (isDebtVoucher) {
              this.$refs.partialTab?.clearDebtVoucherForm?.();
              this.$refs.paymentCancelledTab?.clearDebtVoucherForm?.();
            }
          } else {
            this.ShowToast('Error', data.message, 'error');
          }
        })
        .catch(() =>
          this.ShowToast('', 'Error al obtener los datos.', 'error')
        );
    },
    async deleteBillingDigit(item) {
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar el número de cifra seleccionado?',
        'Si',
        'No'
      );
      if (answer) {
        await _deleteBillingPurchaseOrderNumber(
          item.billingPaymentId,
          item.purchaseOrderNumberId,
          item.lineNumber
        )
          .then(async () => {
            this.ShowToast(
              '',
              'Número de cifra eliminado exitosamente',
              'success'
            );
            await this.getPaymentInformation();
            if (this.billInfo.payments.length == 0) {
              this.billInfo.isPartialPayment = false;
            }
          })
          .catch(() =>
            this.ShowToast(
              '',
              'No ha sido posible eliminar el número de cifra seleccionado.',
              'error'
            )
          );
        await this.getBillingDocuments();
        this.clearBillingPayments();
      }
    },
    clearBillingPayments() {
      this.payment.amount = 0;
      this.payment.paymentId = null;
      this.payment.purchaseOrderNumber = null;
      this.payment.purchaseOrderNumberId = null;

      this.billInfo.addDigitForm = false;
    },
    async cancelPayment(item) {
      //Existe un escenario "_blank";
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar el pago' +
          (item.isPartial ? ' parcial ' : ' ') +
          'seleccionado?',
        'Si',
        'No'
      );
      if (answer) {
        await _cancelPayment(this.billId, item.paymentId, item.isPartial)
          .then(() => {
            this.ShowToast(
              '',
              'El pago' +
                (item.isPartial ? ' parcial ' : ' ') +
                'ha sido eliminado exitosamente',
              'success'
            );
            if (this.isAppoved) {
              this.billInfo.isPartialPayment = false;
            }
            this.clearBillingPayments();
            this.getPaymentInformation();
          })
          .catch(() =>
            this.ShowToast(
              '',
              'No ha sido posible cancelar el pago' +
                (item.isPartial ? ' parcial ' : ' ') +
                '.',
              'error'
            )
          );
      }
    },
    async addPartialPayments() {
      await this.getPaymentInformation();
      this.billInfo.isPartialPayment = true;
      this.billInfo.addDigitForm = true;
      this.payment.purchaseOrderNumberId = null;
      this.payment.purchaseOrderNumber = null;
      this.payment.amount = 0;

      if (this.billInfo.payments.length == 0) {
        this.billInfo.payments.push({
          purchaseTotal: 0,
          showForm: true,
        });
      }

      this.billingInfoTabIndex = BILLING_INFO_TABS.PAYMENT;
      if (this.billModel.statusId == billingStatus.EnviadoFinanzasParcial) {
        this.ShowToast('', 'Preguntarle a PJ.', 'warning');
      }
    },
    ///********************************************************************************************* */
    async callGetBillingTracking(billId) {
      await this[ACTION_TYPES.GET_BILLING_TRACKING](billId);
      this.billingTrackingList = this.billingTracking.slice(0, 5);
    },
    async callGetBillingAdjusmentDetails(billId, payload) {
      this[ACTION_TYPES.GET_BILLING_ADJUSTMENTS_DETAILS_LIST]({
        billId,
        payload,
      });
    },
    async getAdjustmentSummary() {
      await _getBillingAdjustmentSummary(this.billId)
        .then((res) => {
          this.adjustmentSummary = res.data;
        })
        .catch(() =>
          this.ShowToast('', 'Error al obtener los datos.', 'error')
        );
      this.getBillingAdjustmentList();
    },
    async getBillingAdjustmentList() {
      await _getBillingAdjustmentList(this.billId)
        .then((res) => {
          this.originalAdjustmentList = res.data;
        })
        .catch(() =>
          this.ShowToast('', 'Error al obtener los datos.', 'error')
        );
    },
    onSearchAdjustmentDetail(currentPage) {
      const { billId } = this.billModel;
      this.callGetBillingAdjusmentDetails(billId, {
        ...this.billingAdjustmentDetailFilter,
        pageIndex: currentPage ?? 1,
      });
    },
    goToPageHandlerAdjustmentDetails(page) {
      const { billId } = this.billModel;
      this.callGetBillingAdjusmentDetails(billId, {
        ...this.billingAdjustmentDetailFilter,
        pageIndex: page,
        pageSize: 15,
      });
    },
    clearAdjustmentFilterValues() {
      this.$refs.filterRef.value = {
        ...this.$refs.filterRef.value,
        objected: null,
        adjustment: null,
        status: null,
        sie: '',
      };
      this.billingAdjustmentDetailFilter = {
        adjustmentReasonId: null,
        adjustmentType: null,
        objection: null,
        status: null,
        sie: '',
      };
    },
    onChangeAdjusmentType(value) {
      this.clearAdjustmentFilterValues();
      this.billingAdjustmentDetailFilter.adjustmentType = value?.id;
    },
    onChangeAdjustmentObjected(value) {
      this.billingAdjustmentDetailFilter.objection = value?.id;
    },
    onChangeAdjustmentStatus(value) {
      this.billingAdjustmentDetailFilter.status = value?.id;
    },
    onChangeAdjustment(value) {
      this.billingAdjustmentDetailFilter.adjustmentReasonId = value?.id;
    },
    onChangeAdjustmentSie(value) {
      this.billingAdjustmentDetailFilter.sie = value;
    },
    onToggleObjectionForm(value, itemIndex) {
      this[MUTATION_TYPES.SET_BILLING_ADJUSTMENT_OBJECTION]({
        itemIndex,
        prop: {
          addNewObjection: value,
        },
      });
    },
    async deleteObjectionHandler({ visitBillingAdjustmentId }) {
      if (visitBillingAdjustmentId) {
        const answer = await this.ShowCancelModal(
          'Atención',
          '¿Está seguro que desea eliminar la objeción del ajuste?',
          'Si',
          'No'
        );
        if (answer) {
          const {
            data: objectionDeleteResult,
          } = await removeBillingAdjustmentComment(
            visitBillingAdjustmentId
          ).catch((error) => {
            this.ShowToast('Error', error.response.data.message, 'error');
          });
          if (objectionDeleteResult) {
            this.ShowToast(
              '',
              'La objeción fue eliminada exitosamente.',
              'success'
            );
            this.onSearchAdjustmentDetail(this.adjustmentListCurrentPage);
          }
        }
      }
    },
    async changeBillingAdjustmentStatusHandler(
      { visitBillingAdjustmentId, modelRejectReason },
      billingAdjustmentObjectionStatusId
    ) {
      if (visitBillingAdjustmentId && billingAdjustmentObjectionStatusId) {
        const {
          data: changeResult,
        } = await updateBillingAdjustmentStatus(
          visitBillingAdjustmentId,
          billingAdjustmentObjectionStatusId,
          { reason: modelRejectReason }
        );
        if (changeResult) {
          let message = '';
          if (
            billingAdjustmentObjectionStatusId ===
            billingObjectionStatusTypes.Sometida
          ) {
            message = 'La objeción ha sido regresada a sometida exitosamente';
          }
          if (
            billingAdjustmentObjectionStatusId ===
            billingObjectionStatusTypes.Aceptada
          ) {
            message = 'La objeción ha sido aceptada exitosamente';
          }
          if (
            billingAdjustmentObjectionStatusId ===
            billingObjectionStatusTypes.Rechazada
          ) {
            message = 'La objeción ha sido rechazada exitosamente';
          }

          this.ShowToast('', message, 'success');

          //update all
          this.getDetailsInfo();

          this.onSearchAdjustmentDetail(this.adjustmentListCurrentPage);

          this.getAdjustmentSummary();
        }
      }
    },
    showRejectBillingAdjustmentHandler(item) {
      item.showRejectReason = true;
      item.modelRejectReason = null;
      this.$forceUpdate();
    },
    cancelRejectBillingAdjustmentHandler(item) {
      item.modelRejectReason = null;
      item.showRejectReason = false;
      this.$forceUpdate();
    },
    async saveRejectBillingAdjustmentHandler(item, index) {
      this.$forceUpdate();
      const valid = await this.$refs[
        `rejectReasonObserver-${index}`
      ][0].validate();
      if (!valid) {
        this.ShowToast('Error', 'La Razón de Rechazo es obligatoria', 'error');
        return;
      }
      await this.changeBillingAdjustmentStatusHandler(
        item,
        this.getBillingObjectionStatusTypes.Rechazada
      );
    },
    //Adjustment Manual
    onChangeAmountSign(sign) {
      if (!isNaN(this.adjustmentQuantity)) {
        this.adjustmentQuantity =
          sign === 'negative'
            ? -Math.abs(this.adjustmentQuantity)
            : Math.abs(this.adjustmentQuantity);
      }
      if (!isNaN(this.generalAdjustmentModel.amount)) {
        this.generalAdjustmentModel.amount =
          sign === 'negative'
            ? -Math.abs(this.generalAdjustmentModel.amount)
            : Math.abs(this.generalAdjustmentModel.amount);
      }
    },
    async viewBillingAdjusment(item, itemIndex, openedFromTab) {
      //Reset Values
      this.resetServiceAdjustmentForm();

      //Set the current item status
      if (!openedFromTab) {
        item.isOpen = true;
      }

      //Close all the opened records
      for (let i = 0; i < this.pagination.data.length; i++) {
        if (this.pagination.data[i] != item)
          this.pagination.data[i].isOpen = false;
      }
      const { data: detailResponse } = await getAdditionalInfo(
        item.transactionType,
        this.getAdditionalInfoIdByTransactionType(item)
      );

      item.details = {
        ...item.details,
        ...detailResponse,
      };

      //get adjustments
      await this.getBillingServiceAdjustment(item);

      this.itemSelected = item;

      this.visitDetailsTabIndex = BILLING_SERVICE_TABS.ADJUSTMENT;

      await this.$forceUpdate();
    },
    async onDeleteBillingAdjustment(item, adjustmentItem) {
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar el ajuste?',
        'Si',
        'No'
      );
      if (answer) {
        await deleteBillingAdjustment(adjustmentItem.visitBillingAdjustmentId);
        this.ShowToast(
          'Proceso Exitoso.',
          'El ajuste ha sido eliminado exitosamente.',
          'success'
        );
        this[ACTION_TYPES.GET_REASONS]({
          billId: this.billId,
          id: this.itemSelected.id,
          typeId: parseInt(this.adjustmentLevelSelected?.value),
        });
        this.getBillingServiceAdjustment(item); //Listado down
      }
    },
    async onDeleteGeneralBillingAdjustment(adjustmentItem) {
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar el ajuste?',
        'Si',
        'No'
      );
      if (answer) {
        await deleteBillingAdjustment(adjustmentItem.visitBillingAdjustmentId);
        this.ShowToast(
          'Proceso Exitoso.',
          'El ajuste ha sido eliminado exitosamente.',
          'success'
        );
        this.getAdjustmentSummary();
        this.callGetBillingAdjusmentDetails(this.billModel.billId);
        await this.getDetailsInfo();
      }
    },
    async viewAdmissionDetail(item) {
      try {
        const { data } = await _getSignedDocumentByStudentServiceId(
          item.studentServiceId
        );
        if (data.content?.length > 0) {
          data.filename = data.documentTitle;
          await _generalApi.ConvertToBlob(data);
        } else {
          await this.onDownload(data.documentId);
        }
      } catch (err) {
        this.ShowToast(
          'Error',
          err?.response?.data?.message || err?.message,
          'error'
        );
      }
    },
    onChangeLevel() {
      //Save current Level
      this.adjustmentReasonId = null;
      this.adjustmentVisit = null;
      this.adjustmentQuantity = null;
      this[ACTION_TYPES.GET_REASONS]({
        billId: this.billId,
        id: this.itemSelected.id,
        typeId: this.adjustmentLevelSelected?.value,
      });
    },
    onReasonChange(item) {
      const reasonCost = this.getCostbyReasonId()(item.id);
      //avoid cost is 0
      if (reasonCost > 0) {
        if (this.showGeneralAdjustmentForm) {
          this.generalAdjustmentModel.amount = reasonCost;
          return;
        }

        this.adjustmentQuantity = reasonCost;
      }
    },
    async resetServiceAdjustmentForm() {
      this.adjustmentReasonId = null;
      this.adjustmentVisit = null;
      this.visitBillingAdjustmentId = null;
      this.adjustmentComment = null;
      this.adjustmentQuantity = null;
      this.adjustmentLevelSelected = null;

      if (this.$refs?.adjustmentFormRef) {
        this.$refs?.adjustmentFormRef[0]?.reset();
      }
    },
    async saveItemAdjustment(item) {
      //Save Manual Adjustment and call details
      const isValid = await this.$refs.adjustmentFormRef[0].validate(); //[0] Because only showed 1
      if (isValid) {
        let model = {
          billId: this.billId,
          id: item.id, //summary ID or Appoitment ID
          transactionTypeId: item.transactionType,
          levelId: this.adjustmentLevelSelected?.value,
          visitId:
            this.adjustmentVisit != null ? this.adjustmentVisit.id : null,
          adjustmentAmt: parseFloat(this.adjustmentQuantity),
          comments: this.adjustmentComment,
          reasonId: this.adjustmentReasonId.id,
        };
        await this.saveAdjustment(model);
        this.resetServiceAdjustmentForm();
        this[ACTION_TYPES.GET_REASONS]({
          billId: this.billId,
          id: this.itemSelected.id,
          typeId: parseInt(this.adjustmentLevelSelected?.value),
        });
        this.getBillingServiceAdjustment(item);
        await this.getDetailsInfo();
      } else {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
      }
    },
    async onSaveGeneralAdjustment() {
      const isValid = await this.$refs.generalAdjustmentRef.validate(); //[0] Because only showed 1

      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }
      let model = {
        billId: this.billId,
        adjustmentAmt: parseFloat(this.generalAdjustmentModel.amount),
        comments: this.generalAdjustmentModel.comment,
        reasonId: this.generalAdjustmentModel.reason.id,
      };

      await this.saveAdjustment(model);
      await this.ShowToast(
        '',
        'El ajuste ha sido guardado correctamente.',
        'success'
      );
      this.onBillingAdjustmentForm();

      const { billId } = this.billModel;
      this.getAdjustmentSummary();
      this.callGetBillingAdjusmentDetails(billId);
      await this.getDetailsInfo();
    },
    async getBillingServiceAdjustment(item) {
      const { data: response } = await _getBillingServiceAdjustments({
        billId: item.billId,
        id: item.id,
      });
      item.details = {
        ...item.details,
        billingAdjustmentDetails: response,
      };
      this.$forceUpdate();
    },
    async updatePendingFunds() {
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea colocar la factura en pendiente de fondos?',
        'Si',
        'No'
      );
      if (answer) {
        await updatePendingFunds(this.billId)
          .then((res) => {
            if (res.data) {
              this.getIsPendingFunds();
            }
          })
          .catch((error) => {
            this.ShowToast('', error.response.data.message, 'error');
          });
      }
    },
    async getIsPendingFunds() {
      await getIsPendingFunds(this.billId).then((res) => {
        this.isPendingFundsAlert = res.data;
      });
    },
    async onAddPurchaseOrderNumbersHandler(poId) {
      const { companyId, academicYearId } = this.billModel;
      const orderNumbers = (
        await _getSifdePurchaseOrderNumbers(poId, companyId, academicYearId)
      ).data;
      this.billInfo = {
        ...this.billInfo,
        purchaseOrderNumbers: orderNumbers,
      };
    },
    async onUpdateVoucherStatusHandler(voucherNumber) {
      if (voucherNumber) {
        await updateVoucherBill(voucherNumber, this.billId);
        await this.getPaymentInformation();
        await this.getDetailsInfo();
      }
    },
    async onPrintPaymentDistribution(paymentId) {
      await _generalApi.getBillingPaymentDistributionCertification(paymentId);
    },
    onSelectPurchaseOrderHandler(purchaseOrder) {
      if (purchaseOrder) {
        this.onAddPurchaseOrderNumbersHandler(purchaseOrder);
      }
    },
    async onSelectedPagingHandler(value) {
      if (value?.id) {
        this.pageSize = value?.id;
        this.onSearchBillingServiceHandler();
      }
    },
    goToBillingHistorySearch() {
      this.$router.push({ name: 'BillingHistory' });
    },
    async saveNumber(item, index) {
      //Validate
      let isValid = await this.$refs.purchaseOrders[index].validate();

      if (isValid) {
        const payload = [
          {
            id: item.id,
            tableToCkFlag: item.transactionType,
            checked: item.checkedFlag,
            purchaseOrderId:
              item.purchaseOrder !== undefined && item.purchaseOrder !== null
                ? item.purchaseOrder?.id
                : 0,
          },
        ];

        const pageIndex = this.pagination.currentPage;
        await _checkUncheckFlagServiceDetail(payload);

        await this.getProjectNumbersInBill();

        this.appliedFilters = Object.assign({}, this.selectedFilters);
        await this.getBillServiceDetails(pageIndex, {
          categoryId: this.appliedFilters.serviceCategory?.id ?? null,
          serviceId: this.appliedFilters.serviceType?.id ?? null,
          evaluationTypeId: this.appliedFilters.evaluationType?.id ?? null,
          disciplineId: this.appliedFilters.disciplineType?.id ?? null,
          specialistId: this.appliedFilters.specialist?.id ?? null,
          alertId: this.appliedFilters.alert?.id ?? null,
          studentSieId: this.appliedFilters.sie,
          checkedFlag: this.appliedFilters.checkedFlag?.value ?? null,
          pageSize: this.pageSize,
        });
      }
    },
    async getAgeGroup() {
      const { data } = await _getBillingServiceCategories();
      this.ageGroupList = data;
    },
    async onToggleNumberType() {
      //Find all records
      for (let i = 0; i < this.pagination.data.length; i++) {
        if (
          !this.pagination.data[i].checkedFlag &&
          this.isFederalNumber != null &&
          this.isFederalNumber.value
        ) {
          const tempPurchaseOrders = this.purchaseOrdersByCompany.find(
            (x) =>
              x.billingServiceCategoryId == this.pagination.data[i].ageGroupId
          );
          this.pagination.data[i].purchaseOrder = tempPurchaseOrders;
        } else if (
          !this.pagination.data[i].checkedFlag &&
          this.isFederalNumber != null &&
          !this.isFederalNumber.value
        ) {
          const tempPurchaseOrders = this.purchaseOrdersByCompany.find(
            (x) => x.figureTypeId === 2
          );
          this.pagination.data[i].purchaseOrder = tempPurchaseOrders;
        }
      }

      await this.$forceUpdate();
    },
    onShowDistributionDetailsPanel(newValue = true) {
      this.showDistribution = newValue;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

.corner-line {
  border-left: 3px solid map-get($colors, 'secondary-14');
  border-right: 3px solid map-get($colors, 'secondary-14');
}

.dropdown-service-action {
  position: absolute;
  right: -75px;
}

.custom-dropdown-container {
  min-width: 329px;
  .dropdown-item {
    white-space: unset;
    padding: 0.25rem 1rem;
    em {
      margin-right: 10px;
    }
  }
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 80px;
  .toggle-icon {
    flex: 1;
    cursor: pointer;
    text-align: center;
    em {
      margin-top: 12px;
      font-size: 26px;
    }
  }
  .separator-line {
    background: transparent linear-gradient(270deg, #f7f7f700 0%, #efefef 100%)
      0% 0% no-repeat padding-box;
    opacity: 1;
    width: 10px;
    height: 100%;
  }
}
.orange-color {
  color: #ff7058;
}
.green-color {
  color: #2db782;
}

.service-warning-container {
  background: #fff5e8;
  padding: 10px;
  border-radius: 0px 0px 5px 5px;
  margin-top: -16px;
  margin-bottom: 20px;
}

/* overrides */
.custom-callout {
  z-index: 2;
  .col-spacing {
    padding: 18px 15px;
  }
  ::v-deep .tabs {
    border-radius: 4px;
  }
  ::v-deep .callout-container {
    padding: 0px !important;
    border-left-width: 4px;
  }
  ::v-deep .callout-edition {
    margin-top: 3px !important;
    padding: 7px !important;
  }
}

.custom-callout-invoice {
  ::v-deep .callout-container {
    border-left-width: 5px;
  }
}

.input-amount-dollar {
  background: map-get($colors, 'green');
  padding: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  margin-right: -2px;
  z-index: 10;
  em {
    color: map-get($colors, 'white');
  }
}

.input-amount-action {
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  margin-left: -3px;
  z-index: 10;
  em {
    cursor: pointer;
    &:first-child {
      color: map-get($colors, 'green');
      margin-bottom: 5px;
    }
    &:last-child {
      color: map-get($colors, 'primary-5');
    }
  }
}

button:focus {
  outline: unset !important;
}

.no-info {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-left-style: solid;
  border-color: #e8e8e8;
  border-width: 0;
  .no-info-text {
    text-align: left;
    font: Bold 16px/22px Lato;
    letter-spacing: 0;
    color: #727272;
    opacity: 1;
  }
  .no-info-icon {
    color: #727272;
    font-size: 32px;
  }
}

.custom-view-more {
  border-radius: 50px;
  padding: 10px 20px 10px 20px;
}

.custom-circle-loader {
  stroke: #e5f5ef !important;
}

.custom-nav-container ::v-deep {
  .custom-tab-container {
    border-bottom: 1px solid map-get($colors, 'gray-5') !important;
    margin-bottom: 20px !important;
    .nav-item {
      .nav-link {
        font-size: 18px !important;
        color: map-get($colors, 'gray-11') !important;
        &.active {
          border-bottom: 3px solid map-get($colors, 'orange') !important;
          color: map-get($colors, 'orange') !important;
          font-weight: bold !important;
        }
        &.active:after {
          content: unset !important;
        }
      }
    }
  }
  .custom-tab-cursors {
    color: #ff7058;
  }
}

.custom-nav-container-service ::v-deep {
  border-bottom: 1px solid map-get($colors, 'gray-5');
  margin-left: 20px;
  margin-right: 20px;
  .nav-item {
    .nav-link {
      font-size: 14px;
      padding-right: 100px;
      color: map-get($colors, 'gray-6');
      padding-left: 100px;
      &.active {
        border-bottom: 3px solid map-get($colors, 'green');
        color: map-get($colors, 'green');
        font-weight: bold;
      }
      &.active:after {
        content: unset;
      }
    }
  }
}

::v-deep .custom-print-button.outline-success {
  padding-left: 0px;
  padding-right: 2px;
  i {
    font-size: 15px;
    padding-left: 8px;
    padding-right: 0px !important;
  }
}

::v-deep .custom-flag-button {
  padding-left: 0px;
  padding-right: 2px;
  i {
    font-size: 15px;
    padding-left: 8px;
    padding-right: 0px !important;
  }
}

::v-deep .input-label {
  color: map-get($colors, 'gray-6');
  font-size: 14px !important;
  font-weight: normal !important;
}

::v-deep .custom-tab-visit-details {
  .custom-tab-container {
    .nav-item {
      .nav-link {
        color: map-get($colors, 'secondary-6') !important;
        font-size: 0.9rem !important;
        font-weight: normal !important;
        &.active {
          color: map-get($colors, 'green') !important;
          border-bottom: 3px solid map-get($colors, 'green') !important;
          font-weight: bold !important;
        }
      }
    }
  }
}

.custom-radio__extended ::v-deep {
  .custom-radio-container {
    .radio-button {
      display: flex;
      align-items: center;
      border: unset;
      background: transparent;
      margin-right: 30px;
      .rounded-circle {
        margin-right: 10px;
      }
    }
    .bg-checked {
      background: transparent !important;
      .rounded-circle {
        background: map-get($colors, 'secondary-22');
        i {
          & {
            color: map-get($colors, 'white');
          }
        }
      }
    }
    .error {
      background-color: unset !important;
      .rounded-circle {
        border-color: map-get($colors, 'red') !important;
      }
    }
  }
}

.cert-file-input__extended ::v-deep {
  .file-input-container {
    line-height: 1.4;
  }
}

@media only screen and (max-width: 768px) {
  .corner-line {
    border-left: none;
    border-right: none;
  }

  ::v-deep .custom-nav-container {
    border-bottom: 1px solid map-get($colors, 'gray-5');
    .nav-item {
      flex-grow: 1;
      .nav-link {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }

  .billing-details {
    &__board ::v-deep {
      @media only screen and (max-width: 768px) {
        .bg-secondary {
          background: #fff !important;
        }
      }
    }
  }

  .dropdown-doc__extended ::v-deep {
    button {
      width: 100% !important;
    }
    .dropdown-menu {
      left: -68px;
      width: 100%;
    }
  }
}
.educative-info {
  background-color: #ffedbb;
  position: relative;
  bottom: 20px;
  padding: 12px 8px 8px 19px;
  border-radius: 0 0 5px 5px;
  z-index: 1;
}
.educative-info i {
  color: #2db782;
  padding-right: 10px;
}
.educative-info label {
  color: #2db782;
  text-decoration: underline;
}
.educative-info label:hover {
  color: #27a373;
  cursor: pointer;
}
</style>
